/*
 * PFC mount-only product page.
 *
 *   Bare mount / mat board — no frame, no print. Live canvas preview of the
 *   board + bevel-cut aperture window. The customer can drop in a photo to
 *   PREVIEW their print behind the opening, but the mount ships without a
 *   print, so the image is NEVER uploaded — it lives entirely client-side.
 *
 *   - Variant axis = outer Size only.
 *   - Aperture (opening) + board colour = line-item properties, not variants.
 *   - ATC -> plain /cart/add.js with Size / Opening / Board colour properties.
 *
 * Standalone — borrows the moulding page's canvas + cropper + cart patterns
 * but carries none of the frame/mitre/texture/bundle machinery.
 */
(function () {
  var root = document.querySelector('[data-pfc-mount]');
  var cfg = window.PFC_MOUNT;
  if (!root || !cfg || !Array.isArray(cfg.variants) || !cfg.variants.length) return;

  var UI_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
  var NOUN = cfg.vocab === 'mat' ? 'mat' : 'mount';

  // Stripe styles are PRESET by the store via each stripe board option, NOT a
  // user count control. An option carries EITHER:
  //   bands: <n>        → a fixed band count (e.g. 19 = 10 white + 9 coloured)
  //   bandWidthMm: <mm> → a constant physical band width (more bands on larger
  //                       mounts). Count forced ODD → white-first, white-last.
  // Default "Vertical stripes" = fixed 19 (10 white + 9 coloured).
  var STRIPE_MIN_BANDS = 5;
  var STRIPE_BASE_HEX = '#fafaf6';   // = white mount background

  function stripeBandCount(boardW_mm) {
    var c = state.colour || {};
    if (c.bands) return c.bands;                 // fixed count
    if (c.bandWidthMm) {                          // set physical width
      var n = Math.round((boardW_mm || 210) / c.bandWidthMm);
      if (n < STRIPE_MIN_BANDS) n = STRIPE_MIN_BANDS;
      if (n % 2 === 0) n += 1;                     // odd → white-first/last
      return n;
    }
    return 19;                                     // fallback = 10 white + 9 coloured
  }
  // Striped/patterned mounts price higher than plain (anchor: plain A4 £7 →
  // striped A4 £15). Fixed sizes carry a self-referential "stripe" Bundle Pro
  // option (written by pfc-mount-stripe-pricing.py); custom size multiplies the
  // plain raw by this factor and matches a higher ladder bucket.
  // Premium tier multiplier. Comes from the SHARED model so the customiser, the
  // generated `stripe` Bundle Pro upcharge and the Python ladder generator all
  // agree. `cfg.stripeFactor: 1` is still honoured for premium-only products
  // (premium-mount-board), where the host variant IS the premium board and there
  // is no uplift to charge. Superseded: a hardcoded 15/7.
  var STRIPE_FACTOR = cfg.stripeFactor
    || (window.PFCMountPricing && window.PFCMountPricing.knobsFor(cfg.shopCurrency || 'GBP').PREM_MULT)
    || 2.1;
  var STRIPE_PRESETS = (cfg.stripePresets && cfg.stripePresets.length) ? cfg.stripePresets : [
    { label: 'Navy',      hex: '#23395d' },
    { label: 'Black',     hex: '#1a1a1a' },
    { label: 'Sage',      hex: '#7d8c6a' },
    { label: 'Burgundy',  hex: '#6e2433' },
    { label: 'Mustard',   hex: '#c79a3a' },
    { label: 'Dusty pink',hex: '#c98b8b' },
    { label: 'Slate grey',hex: '#6b7280' },
    { label: 'Teal',      hex: '#2e6e6a' }
  ];

  var PERS_FONTS = (cfg.personalisation && cfg.personalisation.fonts) || ['Playfair Display','Cormorant Garamond','EB Garamond','Lora','Cinzel','Montserrat','Poppins','Raleway','Oswald','Dancing Script','Great Vibes','Sacramento'];

  /* ---------- Element refs ---------- */
  var elPreview = root.querySelector('[data-preview]');
  var elCanvas = root.querySelector('[data-preview-canvas]');
  var elSheet = root.querySelector('[data-sheet]');
  var elSheetHandle = root.querySelector('[data-sheet-handle]');
  var elSheetBody = root.querySelector('[data-sheet-body]');
  var elSheetSummary = root.querySelector('[data-sheet-summary]');
  var elSheetPrice = root.querySelector('[data-sheet-price]');
  var elSceneBtns = Array.from(root.querySelectorAll('[data-scene-btn]'));
  var elOrientToggles = Array.from(root.querySelectorAll('[data-orientation-toggle]'));
  var elOrientBtns = Array.from(root.querySelectorAll('[data-orientation-btn]'));
  var elSizeSelect = root.querySelector('[data-size-select]');
  var elSizeTrigger = root.querySelector('[data-size-trigger]');
  var elSizeValue = root.querySelector('[data-size-value]');
  var elSizeList = root.querySelector('[data-size-list]');
  var elSizeUnitBtns = Array.from(root.querySelectorAll('[data-size-unit]'));
  var elCustom = root.querySelector('[data-custom]');
  var elCustomW = root.querySelector('[data-custom-w]');
  var elCustomH = root.querySelector('[data-custom-h]');
  var elCustomUnitBtns = Array.from(root.querySelectorAll('[data-custom-unit]'));
  var elCustomFeedback = root.querySelector('[data-custom-feedback]');
  var elCustomFrameToggle = root.querySelector('[data-custom-frame-toggle]');
  var elCustomOpeningToggle = root.querySelector('[data-custom-opening-toggle]');
  var elOpeningCustom = root.querySelector('[data-opening-custom]');
  var elOpeningW = root.querySelector('[data-opening-w]');
  var elOpeningH = root.querySelector('[data-opening-h]');
  var elOpeningUnitBtns = Array.from(root.querySelectorAll('[data-opening-unit]'));
  var elOpeningFeedback = root.querySelector('[data-opening-feedback]');
  var elApertures = root.querySelector('[data-apertures]');
  var elApertureGrid = root.querySelector('[data-aperture-grid]');
  var elFramesizeChip = root.querySelector('[data-framesize-chip]');
  var elFramesizeVal = root.querySelector('[data-framesize]');
  var elBorderChip = root.querySelector('[data-border-chip]');
  var elBorderVal = root.querySelector('[data-border-size]');
  var elColourGrid = root.querySelector('[data-colour-grid]');
  var elStripeWrap = root.querySelector('[data-stripe-colours]');
  var elStripeGrid = root.querySelector('[data-stripe-grid]');
  var elStripeCustom = root.querySelector('[data-stripe-custom]');
  var elPatternWrap = root.querySelector('[data-pattern-upload]');
  var elPatternDrop = root.querySelector('[data-pattern-drop]');
  var elPatternInput = root.querySelector('[data-pattern-input]');
  var elPatternTitle = root.querySelector('[data-pattern-title]');
  var elOpeningChip = root.querySelector('[data-opening-chip]');
  var elOpeningSize = root.querySelector('[data-opening-size]');
  var elPrice = root.querySelector('[data-price]');
  var elCompare = root.querySelector('[data-compare]');
  var elAddPhoto = root.querySelector('[data-add-photo]');
  var elPrintPrice = root.querySelector('[data-print-price]');
  // Printed personalisation (text/logo) panel.
  var elPersWrap = root.querySelector('[data-pers-wrap]');
  var elPersToggle = root.querySelector('[data-pers-toggle]');
  var elPersPanel = root.querySelector('[data-pers-panel]');
  var elPersPrice = root.querySelector('[data-pers-price]');
  var elPersWarning = root.querySelector('[data-pers-warning]');
  var elPersFitNote = root.querySelector('[data-pers-fit-note]');
  var elPersLogoFields = root.querySelector('[data-pers-logo-fields]');
  var elPersHeading = root.querySelector('[data-pers-heading]');
  var elPersLine2 = root.querySelector('[data-pers-line2]');
  var elPersFontSelect = root.querySelector('[data-pers-font-select]');
  var elPersFontTrigger = root.querySelector('[data-pers-font-trigger]');
  var elPersFontValue = root.querySelector('[data-pers-font-value]');
  var elPersFontList = root.querySelector('[data-pers-font-list]');
  var elPersAlignBtns = Array.from(root.querySelectorAll('[data-pers-align]'));
  var elPersSizeBtns = Array.from(root.querySelectorAll('[data-pers-size]'));
  var elPersSizeGroup = root.querySelector('[data-pers-size-group]');
  var elPersSizeNote = root.querySelector('[data-pers-size-note]');
  var elPersLogoToggle = root.querySelector('[data-pers-logo-toggle]');
  var elPersLogoPosBtns = Array.from(root.querySelectorAll('[data-pers-logo-pos]'));
  var elPersLogoDrop = root.querySelector('[data-pers-logo-drop]');
  var elPersLogoInput = root.querySelector('[data-pers-logo-input]');
  var elPersLogoTitle = root.querySelector('[data-pers-logo-title]');
  var elPersLogoThumb = root.querySelector('[data-pers-logo-thumb]');
  var elUpload = root.querySelector('[data-upload]');
  var elUploadPanel = root.querySelector('[data-upload-panel]');
  var elUploadTitle = root.querySelector('[data-upload-title]');
  var elFileInput = root.querySelector('[data-file-input]');
  // iOS: drop HEIC from accept so the picker hands over a full-res JPEG itself.
  if (elFileInput && window.PFCUploadNormalise) elFileInput.accept = window.PFCUploadNormalise.accept();
  var elRecrop = root.querySelector('[data-recrop-btn]');
  var elReplace = root.querySelector('[data-replace-btn]');
  var elAtc = root.querySelector('[data-atc]');
  var elAtcStatus = root.querySelector('[data-atc-status]');
  var elCropModal = root.querySelector('[data-crop-modal]');
  var elCropImg = root.querySelector('[data-crop-img]');
  var elCropCancel = root.querySelector('[data-crop-cancel]');
  var elCropConfirm = root.querySelector('[data-crop-confirm]');

  /* ---------- State ---------- */
  // Classify a variant's size for the cm/inch list filter. Inch sizes carry a
  // double-quote in the title ('8" x 10"'); everything else (cm + A-series) is
  // metric and shown under 'cm'.
  function variantUnit(v) {
    return (v && v.title && v.title.indexOf('"') !== -1) ? 'in' : 'cm';
  }
  // Default list unit by store: US → inch, UK → cm. (customPricing.usd is the
  // USD-store flag emitted by the section.)
  function defaultSizeUnit() {
    return (cfg.customPricing && cfg.customPricing.usd) ? 'in' : 'cm';
  }

  function initialVariant() {
    if (cfg.defaultSize) {
      var m = cfg.variants.find(function (v) { return v.title === cfg.defaultSize && !v.isCustom; });
      if (m) return m;
    }
    var byId = cfg.variants.find(function (v) { return v.id === cfg.defaultVariantId && !v.isCustom; });
    if (byId) return byId;
    // No explicit default — prefer the first non-custom size in the store's unit
    // so the preselected size matches the default cm/inch toggle.
    var unit = defaultSizeUnit();
    var inUnit = cfg.variants.find(function (v) { return !v.isCustom && variantUnit(v) === unit; });
    if (inUnit) return inUnit;
    return cfg.variants.find(function (v) { return !v.isCustom; }) || cfg.variants[0];
  }

  function initialColour() {
    var want = cfg.defaultColour || 'white';
    var c = (cfg.boardColours || []).find(function (x) { return x.key === want; });
    return c || (cfg.boardColours || [])[0] || { key: 'white', label: 'White', hex: '#fafaf6', border: '#d9d2c0' };
  }

  function customVariant() {
    return cfg.variants.find(function (v) { return v.isCustom; }) || null;
  }

  function normaliseHex(h) {
    if (!h) return null;
    h = String(h).trim();
    if (h[0] !== '#') h = '#' + h;
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(h) ? h : null;
  }

  function isType(t) { return !!(state.colour && state.colour.type === t); }
  function isStripes() { return isType('stripes'); }
  function isPattern() { return isType('pattern'); }
  function isCheckers() { return isType('checkers'); }
  function isGingham() { return isType('gingham'); }
  function isPolka() { return isType('polka'); }
  function isChevron() { return isType('chevron'); }
  function isAccent() { return isType('accent'); }
  // Finishes that use the shared pattern-colour axis (the accent/band colour the
  // visitor picks). Everything except plain colours + uploaded patterns.
  function usesPatternColour() {
    return isStripes() || isCheckers() || isGingham() || isPolka() || isChevron() || isAccent();
  }
  // Any patterned finish prices at the same tier — the 'stripe' Bundle Pro
  // option / STRIPE_FACTOR for custom.
  function isPatterned() { return usesPatternColour() || isPattern(); }
  // The board's flat base colour (what the pattern is drawn over). Stripes draw
  // on STRIPE_BASE_HEX; every other finish (plain OR coloured-base pattern) uses
  // the selected colour's hex. Used for the board fill, the ink-contrast pick,
  // AND the personalisation backing box so the box reads as cleared mount, not a
  // brilliant-white label.
  function boardBaseHex() { return isStripes() ? STRIPE_BASE_HEX : (state.colour.hex || '#fafaf6'); }

  // Premium tier = a patterned finish AND/OR printed text/logo (Decision A,
  // 2026-06-22). Both price at the premium tier via the same reprice path, so the
  // headline price + ATC reprice + custom STRIPE_FACTOR all key off this.
  function premiumActive() { return isPatterned() || isPersActive(); }

  // Human label for the premium line (Bundle Pro line title, set at ATC). Names
  // the ACTUAL finish chosen — the specific pattern and/or printed text — instead
  // of a generic "Striped mount".
  function premiumLineTitle() {
    var noun = (NOUN === 'mat' ? 'mat' : 'mount');
    var pat = isPatterned() ? (state.colour.label || 'Patterned') : '';
    var txt = isPersActive();
    if (pat && txt) return pat + ' ' + noun + ' + printed text';
    if (pat) return pat + ' ' + noun;
    if (txt) return 'Printed text & logo';
    return noun.charAt(0).toUpperCase() + noun.slice(1);
  }

  // The self-referential 'stripe' Bundle Pro option on the current fixed-size
  // variant (null for custom size, or when no premium finish — pattern or text —
  // is active). Reprices the mat line to the premium tier.
  function fixedStripeBundle() {
    if (!premiumActive() || isCustomActive()) return null;
    return ((state.variant && state.variant.bundles) || []).find(function (b) { return b.id === 'stripe'; }) || null;
  }

  // Refresh the displayed price for the current state (size + plain/striped).
  function refreshPrice() {
    // Premium-tier labels depend on pers + pattern state — keep them in sync on
    // every price refresh (text toggle, typing, logo add, colour change).
    updateColourPrices();
    updatePersPrice();
    if (isCustomActive()) { recomputeCustom(); return; }
    var sb = fixedStripeBundle();
    // Fixed size + photo: absorb both into ONE ladder bucket on this variant, so
    // the headline is the real total and the cart is a single line. Falls back to
    // base(+stripe) below if this size's ladder can't reach the combined price.
    state.fixedBucket = null;
    if (photoAbsorbed()) {
      var fb = matchBucketOn(state.variant, fixedRawTotal());
      if (fb) {
        state.fixedBucket = { id: fb.id, price: fb.price };
        if (elPrice) elPrice.textContent = formatMoney(Number(state.variant.price) + upMajor(fb.price) * 100);
        if (elCompare) elCompare.style.display = 'none';
        syncSheet();
        return;
      }
    }
    // Bundle Pro adds bundle.price ON TOP of the host variant base, so the stored
    // price is the UPCHARGE (premium − plain), not the absolute total. Display
    // base + upcharge to match what the cart charges.
    var cents = sb ? (Number(state.variant.price) + upMajor(sb.price) * 100) : Number(state.variant.price);
    if (elPrice) elPrice.textContent = formatMoney(cents);
    if (elCompare) elCompare.style.display = 'none';
    syncSheet();
  }

  function stripePresetLabel(hex) {
    var m = STRIPE_PRESETS.find(function (p) { return p.hex.toLowerCase() === String(hex).toLowerCase(); });
    return m ? m.label : hex;
  }

  var state = {
    variant: initialVariant(),
    orientation: (cfg.initialOrientation === 'landscape') ? 'landscape' : 'portrait',
    aperture: null,          // aperture key for current size ('small' | 'large' | ...)
    colour: initialColour(),
    stripeColour: normaliseHex(cfg.defaultStripeColour) || STRIPE_PRESETS[0].hex,  // coloured-band hex when colour.type === 'stripes'
    sizeUnit: defaultSizeUnit(), // 'cm' | 'in' — which sizes the list shows
    scene: 'flat',           // 'flat' | 'scale'
    userImg: null,           // HTMLImageElement of cropped preview
    patternImg: null,        // HTMLImageElement of an uploaded pattern (board fill)
    patternDataUrl: null,    // pattern image data URL (uploaded to S3 on ATC)
    previewDataUrl: null,
    originalUrl: null,
    srcImg: null,            // HTMLImageElement of the ORIGINAL upload (uncropped)
    cropData: null,          // crop box in the original's natural pixels
    croppedAspect: null,     // the opening ratio the crop above was cut to
    cropStale: false,        // ratio moved on and the original is gone — must recrop
    pendingPrev: null,       // confirmed photo a not-yet-confirmed pick replaced
    cropFor: null,           // S3 url of the original the confirmed crop belongs to
    cropper: null,
    sessionId: cryptoRandom(),
    designId: null,            // ONE design's id, minted fresh on every add-to-cart.
                               // sessionId is per PAGE LOAD: keying uploads on it made
                               // a second board/photo/pattern overwrite the first at
                               // the same S3 path (see pfc-moulding.js).
    customUnit: 'cm',        // 'cm' | 'in'
    customW: 0, customH: 0,  // custom frame (outer) dims in mm
    customBucket: null,      // { id, price } matched ladder bucket
    fixedBucket: null,       // { id, price } combined (mount[+premium]+photo) bucket on a FIXED size
    prevStandardVariant: null, // remembers the standard size when toggling custom frame
    useCustomOpening: false,
    openingUnit: 'cm',
    openingW: 0, openingH: 0, // custom opening dims in mm
    pers: {
      on: false,
      align: 'center',        // 'left' | 'center' | 'right' — the layout (text + logo)
      size: 'm',              // 's' | 'm' | 'l' — discreet physical text size
      font: PERS_FONTS[0],
      heading: '',
      line2: '',
      logoOn: false,          // optional logo/crest
      logoPos: 'above',       // 'above' | 'below' the text
      logoImg: null,
      logoDataUrl: null,
    },
  };

  var MIN_BORDER = 15;       // mm — minimum mount border each side (safety floor for
                             // custom sizes; the aperture map curates standard openings).
                             // 15mm lets the smallest standard combos through (e.g.
                             // 3.5x5" opening on a 5x7" mount = 19mm border) instead of
                             // blocking ATC on a 1mm shortfall against the old 20mm rule.

  // The ORIGINAL photo, uploading in the background from the moment it is picked.
  // The print is cut from it server-side using state.cropData (pfc-photo-source.js).
  var photoSrc = window.PFCPhotoSource ? window.PFCPhotoSource.create({
    signerUrl: cfg.gcfUploadUrl, bucket: cfg.uploadBucket, onChange: syncAtcGate,
  }) : null;
  var adding = false;   // add-to-cart request in flight

  function isCustomActive() { return !!(state.variant && state.variant.isCustom); }

  /* ---------- Dimensions ---------- */
  function parseDim(v) {
    var t = (v && v.options && v.options.Size) || (v && v.title) || '';
    var m = t.match(/(\d+)\s*(?:cm|"|in)?\s*[x×]\s*(\d+)/i);
    if (m) return { w: Number(m[1]), h: Number(m[2]) };
    // NB: an `/^A\d/ -> {w:5,h:7}` branch used to live here — it silently gave
    // EVERY unmapped A-size a 5×7mm board (A5 shipped like that: bogus
    // `Mount external`, preview + opening maths). A-sizes get real mm from the
    // `case` in snippets/pfc-mount-config-json.liquid; anything unmapped must
    // fail visibly rather than invent a size.
    return null;
  }

  // Outer board dimensions in mm, swapped to the displayed orientation.
  function boardDimsMm(v) {
    if (v && v.isCustom) {
      var cw = state.customW || 0, ch = state.customH || 0;
      if (cw === ch) return { w: cw, h: ch };
      var landC = state.orientation === 'landscape';
      return { w: landC ? Math.max(cw, ch) : Math.min(cw, ch),
               h: landC ? Math.min(cw, ch) : Math.max(cw, ch) };
    }
    var d = parseDim(v);
    var baseW = (v && v.widthMm) || (d && d.w) || 0;
    var baseH = (v && v.heightMm) || (d && d.h) || 0;
    if (baseW === baseH) return { w: baseW, h: baseH };
    var landscape = state.orientation === 'landscape';
    return {
      w: landscape ? Math.max(baseW, baseH) : Math.min(baseW, baseH),
      h: landscape ? Math.min(baseW, baseH) : Math.max(baseW, baseH),
    };
  }

  function isSquare(v) {
    var d = boardDimsMm(v);
    return d.w && d.w === d.h;
  }

  function aperturesFor(sizeTitle) {
    return (cfg.apertureMap && cfg.apertureMap[sizeTitle]) || null;
  }

  // Opening (window) dims in mm, swapped to orientation. Priority:
  //   1. custom opening (advanced) — exact mm the customer entered
  //   2. standard frame → preset aperture from the shared size→opening map
  //   3. custom frame, no custom opening → derived default border
  function apertureDims() {
    var landscape = state.orientation === 'landscape';
    function swap(w, h, label) {
      if (w === h) return { w: w, h: h, label: label };
      return { w: landscape ? Math.max(w, h) : Math.min(w, h),
               h: landscape ? Math.min(w, h) : Math.max(w, h), label: label };
    }
    if (state.useCustomOpening && state.openingW && state.openingH) {
      return swap(state.openingW, state.openingH,
                  Math.round(state.openingW) + '×' + Math.round(state.openingH) + 'mm');
    }
    if (isCustomActive()) {
      var b = boardDimsMm(state.variant);
      if (!b.w || !b.h) return null;
      var border = Math.max(40, Math.min(80, Math.min(b.w, b.h) * 0.12));
      var ow = Math.max(30, b.w - border * 2), oh = Math.max(30, b.h - border * 2);
      return { w: ow, h: oh, label: Math.round(ow) + '×' + Math.round(oh) + 'mm' };
    }
    var ap = aperturesFor(state.variant.title);
    var data = ap && state.aperture ? ap[state.aperture] : null;
    if (!data) return null;
    return swap(data.w, data.h, data.label);
  }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var locale = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().indexOf('en') === 0 ? 'en-GB' : undefined;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Bundle Pro conversion ---------- */
  // Bundle Pro charges an add-on (the `stripe` uplift, a ladder bucket, a print
  // bucket) as round(bundle.price x rate) WHOLE presentment units on top of the
  // host variant. bundle.price is a plain base-currency number in a metafield;
  // rate = Shopify.currency.rate (window.PFCBundleRate, layout/theme.liquid) --
  // FX only; the market's price-list % applies to variants, not to add-ons.
  // Variant prices already arrive in presentment. So every comparison and every
  // price shown below is PRESENTMENT: host price + upMajor(bundle.price).
  // Until 2026-09-11 this file added the raw base-currency number to a
  // presentment host price, so every converted market quoted a price the cart
  // never charged (and custom sizes could snap to the wrong bucket). No-op on
  // the store's own market, where the rate is 1.
  // The rate belongs to the HOST LINE the add-on rides on, not to the page:
  // Bundle Pro (v68+) divides that host's presentment cost by its own
  // custom.bundle_host_base, so two variants can legitimately sit on different
  // multiples when a market rounding rule lands them differently. Always pass
  // the host you are quoting against -- the selected mount variant, the Custom
  // Size variant, or the custom-print host -- or the page and the cart drift
  // apart exactly where the rounding rule bites. No base on that host (not yet
  // backfilled) -> Shopify.currency.rate, i.e. today's behaviour.
  function bundleRate(v) {
    v = arguments.length ? v : state.variant;
    if (window.PFCBundleRate) return window.PFCBundleRate(v && v.price, v && v.base);
    var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function upMajor(price, v) { return addonChargeMajor(price, bundleRate(arguments.length > 1 ? v : state.variant)); }

  /* ---------- Custom-size pricing (perimeter → ladder bucket) ---------- */
  var CP = cfg.customPricing || {};

  // Store-currency price for an arbitrary W×H (mm). Delegates to the SHARED
  // model (assets/pfc-mount-pricing-core.js), which is the same function the
  // Python generator uses to build every catalogue ladder — so a custom size
  // equals the defined price at that size by construction, not by coincidence.
  //
  // This PDP sells the mount as the whole order, so the standalone scenario
  // applies: the mount line carries the order's one postage charge.
  //
  // Superseded: perimeter * 2.96 * 2.333 with a floor — an independent model
  // that drifted from every ladder it was supposed to match.
  function shopCurrency() { return cfg.shopCurrency || (CP.usd ? 'USD' : 'GBP'); }
  function pricingCore() { return window.PFCMountPricing || null; }
  function customRawPrice(w, h) {
    var core = pricingCore();
    if (!core) return 0;   // core failed to load — recomputeCustom shows "unavailable"
    return core.mountPrice(shopCurrency(), w, h, 'standard', 'standalone');
  }

  // Round the raw price UP to the nearest ladder bucket on `v` (defaults to the
  // Custom Size variant). Never undercharge. Fixed sizes carry their own ladder
  // too — theirs spans base → base×STRIPE_FACTOR + max photo, so one bucket
  // prices plain/premium × photo on a single line (see matchVariantBucket).
  // `rawPrice` is PRESENTMENT major units (see bundleRate).
  function matchBucketOn(v, rawPrice) {
    var ladder = (v && v.bundles) || [];
    // Bundle Pro adds the converted bucket.price ON TOP of the host variant, so
    // each bucket stores the UPCHARGE. Its charged total = host + upMajor(price);
    // match the raw absolute price against that.
    var base = v ? Number(v.price) / 100 : 0;
    var best = null, bestUp = Infinity;
    ladder.forEach(function (b) {
      // `stripe` is the premium-only bundle (kept for the no-photo path); it is a
      // valid price point, so it can legitimately win on price like any other.
      var up = upMajor(b.price, v);
      if ((up + base) >= rawPrice - 1e-6 && (up < bestUp || (up === bestUp && b.price < best.price))) { best = b; bestUp = up; }
    });
    if (!best && ladder.length) {
      // Above ladder top — clamp to the top bucket.
      best = ladder.reduce(function (a, b) { return b.price > a.price ? b : a; });
    }
    return best;
  }
  function matchBucket(rawPrice) { return matchBucketOn(customVariant(), rawPrice); }

  /* ---------- Size dropdown ---------- */
  // Variant title as the customer sees it: 8" x 10" reads 10" x 8" in
  // landscape. Display-only, like the toggle; A-sizes and squares pass through.
  // Same helper in pfc-moulding.js — change all three together.
  function orientedTitle(t) {
    var m = /^(\s*)(\d+(?:\.\d+)?)(\s*(?:"|\u201d|\u2033|cm|mm|in)?)(\s*[x\u00d7X]\s*)(\d+(?:\.\d+)?)(.*)$/.exec(t || '');
    if (!m) return t;
    var a = parseFloat(m[2]), b = parseFloat(m[5]);
    if (a === b || (state.orientation === 'landscape') === (a > b)) return t;
    return m[1] + m[5] + m[3] + m[4] + m[2] + m[6];
  }
  function renderSizeList() {
    if (!elSizeList) return;
    elSizeList.innerHTML = '';
    cfg.variants.forEach(function (v) {
      if (v.isCustom) return;   // custom frame size lives in the Advanced expander
      if (variantUnit(v) !== state.sizeUnit) return;   // cm/inch filter
      var li = document.createElement('li');
      li.className = 'pfc-moulding__select-option';
      li.setAttribute('role', 'option');
      li.dataset.variantId = String(v.id);
      li.setAttribute('aria-selected', v.id === state.variant.id ? 'true' : 'false');
      var price = document.createElement('span');
      price.className = 'pfc-moulding__select-option-price';
      price.textContent = formatMoney(Number(v.price));
      var label = document.createElement('span');
      label.textContent = orientedTitle(v.title);
      li.appendChild(label);
      li.appendChild(price);
      if (!v.available) { li.classList.add('is-unavailable'); }
      li.addEventListener('click', function () {
        selectVariant(v);
        setSizeOpen(false);
      });
      elSizeList.appendChild(li);
    });
  }

  function setSizeOpen(open) {
    if (!elSizeList || !elSizeTrigger) return;
    elSizeList.hidden = !open;
    elSizeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    elSizeSelect.classList.toggle('is-open', open);
  }

  /* ---------- Apertures ---------- */
  function renderApertures() {
    if (!elApertureGrid) return;
    var ap = aperturesFor(state.variant.title);
    elApertureGrid.innerHTML = '';
    if (!ap) {
      // No defined openings for this size — hide the picker, no aperture.
      state.aperture = null;
      if (elApertures) elApertures.hidden = true;
      return;
    }
    if (elApertures) elApertures.hidden = false;
    var keys = Object.keys(ap);
    // Keep current aperture if still valid, else default to first.
    if (!state.aperture || keys.indexOf(state.aperture) === -1) {
      state.aperture = keys[0];
    }
    keys.forEach(function (key) {
      var data = ap[key];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pfc-moulding__mount-btn';
      btn.dataset.apertureKey = key;
      btn.setAttribute('aria-pressed', key === state.aperture ? 'true' : 'false');
      btn.innerHTML =
        '<span class="pfc-moulding__mount-chip" style="background:transparent;border:1px dashed #c2bcae;"></span>' +
        '<span class="pfc-moulding__mount-label">' + escapeHtml(data.label) + ' opening</span>' +
        '<span class="pfc-moulding__mount-price">fits ' + escapeHtml(data.label) + '</span>';
      btn.addEventListener('click', function () { selectAperture(key); });
      elApertureGrid.appendChild(btn);
    });
  }

  function selectAperture(key) {
    state.aperture = key;
    Array.from(elApertureGrid.querySelectorAll('[data-aperture-key]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.apertureKey === key ? 'true' : 'false');
    });
    updateOpeningChip();
    renderPreview();
    // Fixed sizes DO show the aperture picker, and the opening drives the
    // absorbed photo price — so re-price when it changes.
    repriceIfPhotoAbsorbed();
  }

  function updateOpeningChip() {
    updatePrintPrice();   // opening drives the print price
    updatePersPrice();    // board size drives the personalisation zone price
    updateColourPrices(); // board size drives the patterned (+£) uplift
    var frame = boardDimsMm(state.variant);
    var op = apertureDims();
    // Frame chip
    if (elFramesizeChip && elFramesizeVal) {
      if (frame.w && frame.h) {
        elFramesizeChip.hidden = false;
        elFramesizeVal.textContent = fmtPairDisp(frame.w, frame.h);
      } else { elFramesizeChip.hidden = true; }
    }
    // Opening chip
    if (elOpeningChip && elOpeningSize) {
      if (op) { elOpeningChip.hidden = false; elOpeningSize.textContent = fmtPairDisp(op.w, op.h); }
      else { elOpeningChip.hidden = true; }
    }
    // Border chip = (frame - opening)/2 per axis
    if (elBorderChip && elBorderVal) {
      if (frame.w && op) {
        var bw = (frame.w - op.w) / 2, bh = (frame.h - op.h) / 2;
        elBorderChip.hidden = false;
        elBorderVal.textContent = (Math.round(bw) === Math.round(bh))
          ? fmtDimDisp(bw)
          : fmtPairDisp(bw, bh);
      } else { elBorderChip.hidden = true; }
    }
  }

  // Validate that the opening leaves a usable border inside the frame. Returns
  // null if OK, or an error string.
  function openingError() {
    var frame = boardDimsMm(state.variant);
    var op = apertureDims();
    if (!frame.w || !op) return null;
    if (op.w > frame.w - MIN_BORDER * 2 || op.h > frame.h - MIN_BORDER * 2) {
      return 'Opening too large — leave at least ' + MIN_BORDER + 'mm border each side.';
    }
    if (op.w < 30 || op.h < 30) return 'Opening too small.';
    return null;
  }

  /* ---------- Colours ---------- */
  function renderColours() {
    if (!elColourGrid) return;
    elColourGrid.innerHTML = '';
    (cfg.boardColours || []).forEach(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pfc-moulding__mount-btn';
      btn.dataset.colourKey = c.key;
      btn.setAttribute('aria-pressed', c.key === state.colour.key ? 'true' : 'false');
      var chipStyle;
      if (isPatternedColour(c)) {
        chipStyle = 'background:' + stripeChipGradient(c) + ';border:1px solid ' + (c.border || '#d9d2c0') + ';';
      } else {
        chipStyle = 'background:' + c.hex + ';';
        if (c.border) chipStyle += 'border:1px solid ' + c.border + ';';
      }
      btn.innerHTML =
        '<span class="pfc-moulding__mount-chip" data-chip-for="' + escapeHtml(c.key) + '" style="' + chipStyle + '"></span>' +
        '<span class="pfc-moulding__mount-label">' + escapeHtml(c.label) + '</span>' +
        '<span class="pfc-moulding__mount-price"></span>';
      btn.addEventListener('click', function () { selectColour(c); });
      elColourGrid.appendChild(btn);
    });
    updateColourPrices();
  }

  // Show the patterned-finish uplift (+£) on stripe/checker swatches.
  function patternedUplift() {
    if (isCustomActive()) {
      var raw = customRawPrice(state.customW || 210, state.customH || 297);
      return Math.max(0, raw * (STRIPE_FACTOR - 1) * bundleRate());
    }
    var sb = ((state.variant && state.variant.bundles) || []).find(function (b) { return b.id === 'stripe'; });
    if (sb) return Math.max(0, upMajor(sb.price));   // sb.price IS the upcharge over plain
    return 0;
  }
  function isPatternedColour(c) {
    return !!(c && c.type && c.type !== 'plain');
  }
  // Show each swatch's price RELATIVE to the currently-selected board colour.
  // Plain (white/black) = base tier; patterned (stripes/checkers) = base + uplift.
  //   • plain selected     → plain swatches "+ £0", patterned "+ £x"
  //   • patterned selected → patterned swatches "+ £0", plain "− £x"
  function updateColourPrices() {
    if (!elColourGrid) return;
    // Printed text/logo already puts the line at the premium tier, so switching
    // to a patterned board then costs nothing extra → show no uplift on any
    // swatch. Otherwise it's the normal plain→patterned uplift.
    var up = isPersActive() ? 0 : patternedUplift();  // patterned-tier uplift (£, major units)
    var selPat = isPatternedColour(state.colour);
    (cfg.boardColours || []).forEach(function (c) {
      var btn = elColourGrid.querySelector('[data-colour-key="' + c.key + '"]');
      if (!btn) return;
      var ps = btn.querySelector('.pfc-moulding__mount-price');
      if (!ps) return;
      if (up <= 0) { ps.textContent = ''; return; }   // no patterned uplift at this size
      var delta = up * ((isPatternedColour(c) ? 1 : 0) - (selPat ? 1 : 0));
      if (Math.abs(delta) < 0.005) ps.textContent = '+ ' + formatMoney(0);
      else if (delta > 0)          ps.textContent = '+ ' + formatMoney(Math.round(delta * 100));
      else                         ps.textContent = '− ' + formatMoney(Math.round(-delta * 100));
    });
  }

  // CSS gradient mimicking the drawn stripe pattern, for swatch chips. The chip
  // band width reflects the option's style (fine for set-width, coarse for the
  // fixed 19-band look) so the two stripe swatches read differently.
  function stripeChipGradient(c) {
    c = c || state.colour || {};
    var a = state.stripeColour;
    if (c.type === 'checkers') {
      return 'repeating-conic-gradient(' + a + ' 0% 25%, ' + STRIPE_BASE_HEX + ' 0% 50%) 0 / 9px 9px';
    }
    if (c.type === 'gingham') {
      return 'repeating-linear-gradient(0deg,' + a + ' 0 2px,transparent 2px 7px),' +
             'repeating-linear-gradient(90deg,' + a + ' 0 2px,transparent 2px 7px),' + STRIPE_BASE_HEX;
    }
    if (c.type === 'polka') {
      return 'radial-gradient(' + a + ' 30%, transparent 33%) 0 0 / 8px 8px, ' + STRIPE_BASE_HEX;
    }
    if (c.type === 'chevron') {
      return 'repeating-linear-gradient(135deg,' + a + ' 0 2px,' + STRIPE_BASE_HEX + ' 2px 5px)';
    }
    if (c.type === 'accent') {
      return 'radial-gradient(closest-side, ' + STRIPE_BASE_HEX + ' 52%, ' + a + ' 55% 74%, ' + STRIPE_BASE_HEX + ' 77%)';
    }
    // stripes (vertical / horizontal / fine)
    var deg = c.orient === 'h' ? 0 : 90;
    var u = c.bandWidthMm ? 2 : 4;
    return 'repeating-linear-gradient(' + deg + 'deg,' + STRIPE_BASE_HEX + ' 0 ' + u + 'px,' + a + ' ' + u + 'px ' + (u * 2) + 'px)';
  }

  function updateStripeChip() {
    if (!elColourGrid) return;
    (cfg.boardColours || []).forEach(function (c) {
      if (!isPatternedColour(c)) return;
      var chip = elColourGrid.querySelector('[data-chip-for="' + c.key + '"]');
      if (chip) chip.style.background = stripeChipGradient(c);
    });
  }

  function selectColour(c) {
    state.colour = c;
    Array.from(elColourGrid.querySelectorAll('[data-colour-key]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.colourKey === c.key ? 'true' : 'false');
    });
    if (elStripeWrap) elStripeWrap.hidden = !usesPatternColour();
    if (elPatternWrap) elPatternWrap.hidden = !isPattern();
    updatePersWarning();   // (no-op now — text works on any board)
    updateColourPrices();  // re-derive each swatch's price relative to new selection
    updatePersPrice();     // text uplift shows "included" once a pattern is selected
    refreshPrice();
    renderPreview();
  }

  /* ---------- Stripe-colour picker ---------- */
  function renderStripePicker() {
    if (!elStripeGrid) return;
    elStripeGrid.innerHTML = '';
    STRIPE_PRESETS.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pfc-mount__stripe-swatch';
      btn.dataset.stripeHex = p.hex;
      btn.title = p.label;
      btn.setAttribute('aria-label', p.label);
      btn.setAttribute('aria-pressed', p.hex.toLowerCase() === state.stripeColour.toLowerCase() ? 'true' : 'false');
      btn.style.background = p.hex;
      btn.addEventListener('click', function () { setStripeColour(p.hex); });
      elStripeGrid.appendChild(btn);
    });
    if (elStripeCustom) elStripeCustom.value = state.stripeColour;
  }

  function setStripeColour(hex) {
    var norm = normaliseHex(hex);
    if (!norm) return;
    state.stripeColour = norm;
    if (elStripeGrid) {
      Array.from(elStripeGrid.querySelectorAll('[data-stripe-hex]')).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.stripeHex.toLowerCase() === norm.toLowerCase() ? 'true' : 'false');
      });
    }
    if (elStripeCustom && elStripeCustom.value.toLowerCase() !== norm.toLowerCase()) elStripeCustom.value = norm;
    updateStripeChip();
    renderPreview();
  }

  /* ---------- Variant selection ---------- */
  function selectVariant(v) {
    state.variant = v;
    var custom = !!v.isCustom;
    if (elSizeValue) elSizeValue.textContent = custom ? 'Custom size' : orientedTitle(v.title);
    if (elSizeList) {
      Array.from(elSizeList.children).forEach(function (li) {
        li.setAttribute('aria-selected', Number(li.dataset.variantId) === v.id ? 'true' : 'false');
      });
    }
    if (elCustom) elCustom.hidden = !custom;

    if (custom) {
      recomputeCustom();   // sets price + bucket from current inputs
    } else {
      var sb = fixedStripeBundle();
      if (elPrice) elPrice.textContent = formatMoney(sb ? (Number(v.price) + upMajor(sb.price, v) * 100) : Number(v.price));
      if (elCompare) {
        var cap = Number(v.compareAtPrice || 0);
        if (!sb && cap > Number(v.price)) { elCompare.textContent = formatMoney(cap); elCompare.style.display = ''; }
        else { elCompare.style.display = 'none'; }
      }
    }
    // Orientation toggle only for non-square sizes (custom: show, user may be non-square).
    elOrientToggles.forEach(function (w) { w.hidden = custom ? false : isSquare(v); });
    // Preset opening picker: standard frame only, and not when a custom opening is on.
    if (!custom && !state.useCustomOpening) {
      renderApertures();
    } else if (elApertures) {
      elApertures.hidden = true;
    }
    updateOpeningChip();
    applyPreviewAspect();
    renderPreview();
    syncSheet();
  }

  function syncSheet() {
    if (elSheetSummary) {
      elSheetSummary.textContent = isCustomActive()
        ? (state.customW && state.customH ? ('Custom ' + Math.round(state.customW) + '×' + Math.round(state.customH) + 'mm') : 'Custom size')
        : state.variant.title;
    }
    if (elSheetPrice && elPrice) elSheetPrice.textContent = elPrice.textContent;
    // Echo the running total on the Add-to-cart button so it stays visible once
    // the controls push the headline price above the fold.
    if (elAtc && elPrice && !(photoSrc && (photoSrc.busy() || photoSrc.failed()))) {
      var pt = elPrice.textContent;
      elAtc.textContent = (pt && pt !== '—') ? ('Add to cart · ' + pt) : 'Add to cart';
    }
  }

  /* ---------- Custom size recompute ---------- */
  function toMm(val) {
    if (!val || val <= 0) return 0;
    return state.customUnit === 'in' ? val * 25.4 : val * 10;  // cm or inch
  }

  function recomputeCustom() {
    var w = toMm(parseFloat(elCustomW && elCustomW.value));
    var h = toMm(parseFloat(elCustomH && elCustomH.value));
    state.customW = w; state.customH = h;
    state.customBucket = null;
    var min = CP.minMm || 100, max = CP.maxMm || 1200;

    if (!w || !h) {
      setCustomFeedback('Enter a width and height.', false);
      if (elPrice) elPrice.textContent = '—';
      renderPreview(); return;
    }
    if (w < min || h < min) {
      setCustomFeedback('Minimum ' + fmtSide(min) + ' each side.', false);
      if (elPrice) elPrice.textContent = '—';
      renderPreview(); return;
    }
    if (w > max || h > max) {
      setCustomFeedback('Maximum ' + fmtSide(max) + ' each side.', false);
      if (elPrice) elPrice.textContent = '—';
      renderPreview(); return;
    }
    var raw = customRawPrice(w, h);
    if (premiumActive()) raw = raw * STRIPE_FACTOR; // premium custom (pattern and/or printed text) = plain raw × factor → higher bucket
    // Absorb the photo into the SAME bucket (custom size only). The ladder spans
    // mount-only AND mount+photo (£8–£175), so one bucket prices the whole line.
    // STRIPE_FACTOR uplifts the MOUNT only — the print isn't a premium surface.
    if (photoAbsorbed() && photoPriceActive()) {
      // Print price + the adhering labour. ADHERE is a fixed job charge from the
      // shared model — same figure the print customiser adds for a mounted print,
      // so the two customisers quote the same mount+photo price.
      var coreP = pricingCore();
      raw += printPriceValue()
           + (coreP ? coreP.knobsFor(shopCurrency()).ADHERE : 0);
    }
    var bucket = matchBucket(raw * bundleRate(customVariant()));   // raw is base currency -> presentment
    if (!bucket) {
      setCustomFeedback('Size unavailable — please contact us.', false);
      if (elPrice) elPrice.textContent = '—';
      renderPreview(); return;
    }
    var cBase = (function () { var cv = customVariant(); return cv ? Number(cv.price) : 0; })();
    state.customBucket = { id: bucket.id, price: bucket.price };
    if (elPrice) elPrice.textContent = formatMoney(cBase + upMajor(bucket.price, customVariant()) * 100);
    if (elCompare) elCompare.style.display = 'none';
    setCustomFeedback(fmtSide(w) + ' × ' + fmtSide(h), true);
    updateOpeningChip();
    applyPreviewAspect();
    renderPreview();
    syncSheet();
  }

  /* ---------- Custom opening recompute ---------- */
  function recomputeOpening() {
    var w = (state.openingUnit === 'in' ? 25.4 : 10) * (parseFloat(elOpeningW && elOpeningW.value) || 0);
    var h = (state.openingUnit === 'in' ? 25.4 : 10) * (parseFloat(elOpeningH && elOpeningH.value) || 0);
    state.openingW = w; state.openingH = h;
    updateOpeningChip();
    var err = openingError();
    if (elOpeningFeedback) {
      if (!w || !h) { elOpeningFeedback.textContent = 'Enter your print size.'; elOpeningFeedback.dataset.ok = 'false'; }
      else if (err) { elOpeningFeedback.textContent = err; elOpeningFeedback.dataset.ok = 'false'; }
      else { elOpeningFeedback.textContent = (state.openingUnit === 'in' ? ((w / 25.4).toFixed(1) + ' × ' + (h / 25.4).toFixed(1) + '"') : ((w / 10) + ' × ' + (h / 10) + 'cm')); elOpeningFeedback.dataset.ok = 'true'; }
    }
    renderPreview();
    repriceIfPhotoAbsorbed();   // opening area drives the absorbed photo price
  }

  function fmtSide(mm) {
    return state.customUnit === 'in' ? (mm / 25.4).toFixed(1) + '"' : (mm / 10) + 'cm';
  }
  // Display-unit formatters for badges/labels — follow the cm/in size toggle so
  // EVERY shown dimension converts to inches in inch mode (no stray mm).
  function dispIn() { return state.sizeUnit === 'in'; }
  function fmtDimDisp(mm) {
    if (dispIn()) { var v = mm / 25.4; return (v < 2 ? v.toFixed(2) : v.toFixed(1)) + '"'; }
    return (Math.round(mm / 10 * 10) / 10) + 'cm';
  }
  function fmtPairDisp(w, h) {
    if (dispIn()) return (w / 25.4).toFixed(1) + '×' + (h / 25.4).toFixed(1) + '"';
    return (Math.round(w / 10 * 10) / 10) + '×' + (Math.round(h / 10 * 10) / 10) + 'cm';
  }
  // Exact production dims for the order line (framer cut sizes): whole mm in
  // metric, 2dp inch in inch mode — NOT fmtPairDisp (rounds to cm, too coarse to
  // cut from). Mirrors pfc-moulding.js fmtProdDim. See docs/ORDER-MOUNT-DIMS-SPEC.md.
  // Sizes defined in INCHES are carried as whole mm (11" -> 279mm, 14" -> 356mm),
  // so converting those mm back put 10.98×14.02" on the order. When a size or
  // opening was defined in inches, take the exact inches from its label
  // ('11" x 14"', '5"×7"'), matched to the mm pair so orientation follows.
  // Metric ones (an A2 opening in an inch frame, cm sizes) keep the mm conversion.
  // Same helper in pfc-moulding.js and pfc-mount.js - keep in step.
  function exactInchPair(wMm, hMm, label) {
    var m = String(label || '').match(/(\d+(?:\.\d+)?)\s*["”]\s*[x×]\s*(\d+(?:\.\d+)?)\s*["”]/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    var keep = Math.abs(wMm - a * 25.4) + Math.abs(hMm - b * 25.4);
    var swap = Math.abs(wMm - b * 25.4) + Math.abs(hMm - a * 25.4);
    var p = keep <= swap ? { w: a, h: b } : { w: b, h: a };
    // Only when the mm really are this size, rounded to whole mm.
    return (Math.abs(wMm - p.w * 25.4) <= 1 && Math.abs(hMm - p.h * 25.4) <= 1) ? p : null;
  }
  function fmtInch(x) { return String(Number(x.toFixed(2))); }
  // A dimension is written in the unit that DEFINED it, not the list the customer
  // browsed: an inch size in exact inches; an A-size in mm with its name, so an
  // A4 bought from the inch list reads 210×297mm (A4) rather than 8.27×11.69";
  // a cm size in mm. With no defining label (custom sizes), the display unit.
  function fmtProdDim(wMm, hMm, label) {
    var ex = exactInchPair(wMm, hMm, label);
    if (ex) return fmtInch(ex.w) + '×' + fmtInch(ex.h) + '"';
    var a = /^\s*A([0-9])\s*$/i.exec(String(label || ''));
    var metric = !!a || /\d\s*(?:cm|mm)\b/i.test(String(label || ''));
    if (metric || !dispIn()) return Math.round(wMm) + '×' + Math.round(hMm) + 'mm' + (a ? ' (A' + a[1] + ')' : '');
    return fmtInch(wMm / 25.4) + '×' + fmtInch(hMm / 25.4) + '"';
  }
  function setCustomFeedback(text, ok) {
    if (!elCustomFeedback) return;
    elCustomFeedback.textContent = text || '';
    elCustomFeedback.dataset.ok = ok ? 'true' : 'false';
  }

  /* ---------- Preview aspect ---------- */
  function applyPreviewAspect() {
    if (!elPreview) return;
    // FIXED SQUARE STAGE — mirrors the moulding customiser
    // (pfc-moulding.js applyPreviewAspect / pfc-moulding.css aspect-ratio: 1/1).
    // The stage must NOT reshape on orientation/size change: a <canvas> is a
    // replaced element whose intrinsic aspect = its backing-store dims, so a
    // reshaping container CSS-stretches the old bitmap (board + photo squashed).
    // Keep the stage square and draw the board to scale inside it (MARGIN fit) —
    // orientation/size just changes the board rect, the photo cover-crops into
    // the opening, nothing is ever non-uniformly scaled.
    elPreview.style.aspectRatio = '1 / 1';
  }

  /* ---------- Printed personalisation (text / logo) ---------- */
  function persConfig() { return cfg.personalisation || {}; }
  // Availability is the section's flag alone. It used to ALSO require
  // `persConfig().zones` (variants of the Print Personalisation product), which
  // vanished whenever that product left the Online Store channel — killing the
  // panel silently. Zone prices were never read: the uplift is the premium tier
  // (patternedUplift), so the extra condition only ever broke things.
  function persAvailable() { return !!persConfig().available; }
  // Layout = alignment (left/center/right). Logo is an optional toggle stacked
  // above or below the text. No more side-by-side / preset layouts.
  function persHasText() { return !!((state.pers.heading && state.pers.heading.trim()) || (state.pers.line2 && state.pers.line2.trim())); }
  function persHasLogo() { return !!(state.pers.logoOn && state.pers.logoImg); }
  function persHasContent() { return persHasText() || persHasLogo(); }
  // Printed personalisation works on ANY board now — the white backing box drawn
  // by drawPersonalisation keeps it legible over plain OR patterned (Decision A,
  // 2026-06-22). Kept as a function (always true) so callers stay unchanged.
  function persAllowedColour() { return true; }
  function isPersActive() { return state.pers.on && persAvailable() && persHasContent() && persFits(); }
  function updatePersWarning() {
    if (elPersWarning) elPersWarning.hidden = true; // no white-only restriction any more
  }

  /* ---------- Narrow-border guard ----------
     The printed line lives in the BOTTOM border, minus the rebate-safe edge
     inset and the bevel gap. A small board with a big opening leaves almost
     nothing: 150×200mm with a 5×7" (127×178mm) window = an 11mm bottom border,
     so the band is 11 − 12 − 3 = NEGATIVE and every draw call silently skipped
     — the customer typed text and saw nothing. Block the add-on with a reason
     instead, and keep the threshold in mm (the old `> 8` tests were canvas px,
     so the same mount passed or failed depending on viewport size). */
  var PERS_MIN_BAND_MM = 14;   // ≈4mm cap height once the 3mm box pad comes off
  function persBottomBorderMm() {
    var b = boardDimsMm(state.variant);
    if (!b || !b.h) return 0;
    var ap = apertureDims();
    return ap && ap.h ? (b.h - ap.h) / 2 : b.h * 0.40;   // fallback mirrors the preview
  }
  function persBandMm() {
    var bb = persBottomBorderMm();
    return bb > 0 ? bb - PERS_EDGE_MM - PERS_GAP_MM : 0;
  }
  function persFits() { return persBandMm() >= PERS_MIN_BAND_MM; }
  function persFitMessage() {
    var bb = Math.round(persBottomBorderMm());
    var need = Math.ceil(PERS_MIN_BAND_MM + PERS_EDGE_MM + PERS_GAP_MM);
    return 'Printed text needs a wider border — this ' + NOUN + '’s bottom border is '
      + bb + 'mm and printing needs at least ' + need + 'mm. Choose a larger '
      + NOUN + ' size or a smaller opening.';
  }
  // Disable the add-on (and say why) whenever the bottom border is too narrow.
  function updatePersFit() {
    var fits = persFits();
    if (elPersToggle) elPersToggle.disabled = !fits;
    if (elPersWrap) elPersWrap.classList.toggle('is-blocked', !fits);
    if (elPersPanel) elPersPanel.hidden = !fits || !state.pers.on;
    if (elPersFitNote) {
      elPersFitNote.hidden = fits;
      if (!fits) elPersFitNote.textContent = persFitMessage();
    }
  }
  function fontFamilyCss(name) { return '"' + name + '", ' + UI_FONT; }
  function persInk() {
    var hex = boardBaseHex().replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(hex.substr(0, 2), 16), g = parseInt(hex.substr(2, 2), 16), b = parseInt(hex.substr(4, 2), 16);
    return ((0.299 * r + 0.587 * g + 0.114 * b) / 255) > 0.55 ? '#1a1a1a' : '#ffffff';
  }
  // Personalisation text size: physical heading em height in mm by S/M/L step.
  // Discreet by default; never grows past this regardless of border size.
  var PERS_CAP_MM = { xs: 3.5, s: 5, m: 7, l: 9 };
  // Fit-by-space (assets/pfc-pers-fit-core.js): the chosen size prints exactly,
  // the text zone is the opening width, and the room left is what varies. Off
  // unless the theme setting pers_fit_v2 is on or the URL has ?pers_fit=1 —
  // when off, pf() is a stub and every path below behaves as before.
  var PF = window.PFCPersFit || null;
  var persFit = null;
  // A function declaration, so it works during the first render — which runs
  // before this part of the file has executed (a `var` stub would be undefined).
  function pf() {
    return persFit || pf.stub || (pf.stub = {
      enabled: false, update: function () {}, addError: function () { return null; }, exact: function () { return false; }
    });
  }
  // Text zone in mm ({w, h}) for the current board, or null when there is none.
  function persZoneMm() {
    if (!PF) return null;
    var b = boardDimsMm(state.variant), ap = apertureDims();
    if (!b || !b.w || !ap || !ap.w) return null;
    var band = persBandMm(); if (band <= 0) return null;
    return { w: PF.zoneWidthMm(ap.w, b.w, PERS_EDGE_MM, PERS_BOXPAD_MM),
             h: PF.textZoneHeightMm(band, PERS_BOXPAD_MM, persHasLogo()) };
  }
  // The band the text is drawn in, in canvas px. Legacy: the full board width
  // inside the rebate-safe edge. Fit-by-space: centred, as wide as the opening.
  function persRect(boardLeft, boardWpx, top, bottom, pxPerMm) {
    var edge = PERS_EDGE_MM * pxPerMm;
    var z = pf().enabled ? persZoneMm() : null;
    if (!z) return { x: boardLeft + edge, y: top, w: boardWpx - edge * 2, h: bottom - top };
    var pad = PERS_BOXPAD_MM * pxPerMm, zw = z.w * pxPerMm;
    var ins = PF.alignInsetMm(persMeasureCtx(), fontFamilyCss(state.pers.font),
      [state.pers.heading, state.pers.line2], persCapMm(), state.pers.align || 'center');
    return { x: boardLeft + (boardWpx - zw) / 2 - pad + ins.l * pxPerMm, y: top,
             w: zw + pad * 2 - (ins.l + ins.r) * pxPerMm, h: bottom - top };
  }
  // Vector text spec for the print-file app (fit-by-space, text-only designs):
  // the same shape pfc-moulding.js sends, so the print re-renders at the exact
  // chosen size instead of being re-fitted from the PNG.
  var lastPersRenderSpec = null;
  function persCapMm() { return PERS_CAP_MM[state.pers.size] || PERS_CAP_MM.m; }
  // Effective rendered font px for a given cap within a text zone (mirrors
  // drawTextBlock's width/height fit) — used to detect when S/M/L steps would
  // produce the same (space-limited) result so dead toggles can be disabled.
  function persMeasureCtx() { persMeasureCtx._c = persMeasureCtx._c || document.createElement('canvas').getContext('2d'); return persMeasureCtx._c; }
  function persStepFitPx(zoneW, zoneH, capPx) {
    var lines = [state.pers.heading, state.pers.line2].filter(function (t) { return t && t.trim(); });
    var n = lines.length || 1, fam = fontFamilyCss(state.pers.font);
    var size = Math.min((zoneH / (n + 0.4)) * 0.74, capPx, zoneH / (1.32 * n));
    var ctx = persMeasureCtx();
    lines.forEach(function (t) { var s = size; ctx.font = '600 ' + s + 'px ' + fam; while (ctx.measureText(t).width > zoneW && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; } if (s < size) size = s; });
    return Math.max(6, size);
  }
  // Disable S/M/L steps that can't grow the text (space-limited); if ALL collapse
  // to one size, hide the control + show the auto-sized note.
  function syncPersSizeSteps(zoneW, zoneH, pxPerMm) {
    if (pf().enabled) { pf().update(); return; }
    if (!elPersSizeBtns.length) return;
    var reset = !persHasText() || !zoneW || !zoneH;
    if (reset) {
      if (elPersSizeGroup) elPersSizeGroup.hidden = false;
      if (elPersSizeNote) elPersSizeNote.hidden = true;
      elPersSizeBtns.forEach(function (b) { b.disabled = false; b.setAttribute('aria-pressed', b.dataset.persSize === state.pers.size ? 'true' : 'false'); });
      return;
    }
    var keys = ['s', 'm', 'l'], eff = {};
    keys.forEach(function (k) { eff[k] = Math.round(persStepFitPx(zoneW, zoneH, PERS_CAP_MM[k] * pxPerMm)); });
    var allSame = (eff.s === eff.m && eff.m === eff.l);
    if (elPersSizeGroup) elPersSizeGroup.hidden = allSame;
    if (elPersSizeNote) elPersSizeNote.hidden = !allSame;
    if (allSame) return;
    var prevEff = null;
    keys.forEach(function (k) {
      var btn = elPersSizeBtns.find(function (b) { return b.dataset.persSize === k; });
      if (!btn) return;
      var noop = prevEff !== null && eff[k] <= prevEff;   // doesn't grow vs smaller step
      btn.disabled = noop;
      btn.setAttribute('aria-pressed', k === state.pers.size ? 'true' : 'false');
      prevEff = eff[k];
    });
  }
  // Rebate-safe inset (mm) from the outer mount edge so a frame rebate can't
  // cover the text; small gap (mm) to clear the aperture bevel; box pad (mm).
  var PERS_EDGE_MM = 12, PERS_GAP_MM = 3, PERS_BOXPAD_MM = 3;
  function updatePersPrice() {
    if (!elPersPrice) return;
    // Decision A: printed text/logo prices at the PREMIUM tier (same as a pattern).
    // If a pattern is already selected the line is already premium → text is
    // included at no extra; otherwise show the premium uplift for this size.
    if (isPatterned()) { elPersPrice.textContent = 'included'; return; }
    var up = patternedUplift();
    elPersPrice.textContent = up > 0 ? ('+ ' + formatMoney(Math.round(up * 100))) : '';
  }

  function drawLogoFit(ctx, img, x, y, w, h, align) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height; if (!iw || !ih) return;
    var s = Math.min(w / iw, h / ih), dw = iw * s, dh = ih * s;
    var dx = align === 'left' ? x : align === 'right' ? (x + w - dw) : (x + (w - dw) / 2);
    ctx.drawImage(img, dx, y + (h - dh) / 2, dw, dh);
  }
  // The on-page canvas inherits the page's CSS letter-spacing (0.6px), which
  // canvas text honours — so the preview drew every line wider than the print
  // file (off-screen canvases have none). Mount text is always drawn unspaced.
  function drawTextBlock(ctx, lines, x, y, w, h, align, ink, capPx) {
    lines = lines.filter(function (t) { return t && t.trim(); });
    if (!lines.length) return;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    var fam = fontFamilyCss(state.pers.font), n = lines.length, lineH = h / (n + 0.4), base = lineH * 0.74;
    if (capPx) base = Math.min(base, capPx);   // cap to the chosen physical mm size
    var size = base;
    lines.forEach(function (t) {
      if (pf().exact()) return;   // fit-by-space: the chosen size is what prints
      var s = base; ctx.font = '600 ' + s + 'px ' + fam;
      while (ctx.measureText(t).width > w && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; }
      if (s < size) size = s;
    });
    ctx.font = '600 ' + size + 'px ' + fam;
    ctx.fillStyle = ink; ctx.textAlign = align;
    // Centre each line on the font's own ascent/descent, NOT textBaseline
    // 'middle': Chrome and the print-file app (node-canvas) disagree on where
    // 'middle' is (~0.8 mm at M), but agree exactly on these metrics — and this
    // is where the print app has always put the line.
    ctx.textBaseline = 'alphabetic';
    var fm = ctx.measureText('Hxg');
    var asc = fm.fontBoundingBoxAscent != null ? fm.fontBoundingBoxAscent : (fm.emHeightAscent != null ? fm.emHeightAscent : size * 0.8);
    var desc = fm.fontBoundingBoxDescent != null ? fm.fontBoundingBoxDescent : (fm.emHeightDescent != null ? fm.emHeightDescent : size * 0.2);
    var mid = (asc - desc) / 2;
    var tx = align === 'left' ? x : align === 'right' ? (x + w) : (x + w / 2);
    // Line spacing from the FINAL size (not the zone) so a capped, discreet block
    // stays tightly set instead of spreading across a tall border.
    var lh = size * 1.32;
    var startY = y + (h - lh * n) / 2 + lh / 2;
    lines.forEach(function (t, i) { ctx.fillText(t, tx, startY + i * lh + mid); });
  }
  // Bounding box (as drawn) of a fitted logo within (x,y,w,h) — mirrors drawLogoFit.
  function persLogoRect(x, y, w, h, align) {
    var logo = state.pers.logoImg; if (!logo) return null;
    var iw = logo.naturalWidth || logo.width, ih = logo.naturalHeight || logo.height; if (!iw || !ih) return null;
    var s = Math.min(w / iw, h / ih), dw = iw * s, dh = ih * s;
    var dx = align === 'left' ? x : align === 'right' ? (x + w - dw) : (x + (w - dw) / 2);
    return { x: dx, y: y + (h - dh) / 2, w: dw, h: dh };
  }
  // Bounding box (as drawn) of the fitted text block within (x,y,w,h) — mirrors drawTextBlock.
  function persTextRect(ctx, x, y, w, h, align, capPx) {
    var ls = [state.pers.heading, state.pers.line2].filter(function (t) { return t && t.trim(); });
    if (!ls.length) return null;
    var prevLs = ctx.letterSpacing;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    var fam = fontFamilyCss(state.pers.font), n = ls.length, lineH = h / (n + 0.4), base = lineH * 0.74, size = base;
    if (capPx) base = size = Math.min(base, capPx);
    ls.forEach(function (t) { if (pf().exact()) return; var s = base; ctx.font = '600 ' + s + 'px ' + fam; while (ctx.measureText(t).width > w && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; } if (s < size) size = s; });
    ctx.font = '600 ' + size + 'px ' + fam;
    var tw = 0; ls.forEach(function (t) { tw = Math.max(tw, ctx.measureText(t).width); });
    var tl = align === 'left' ? x : align === 'right' ? (x + w - tw) : (x + (w - tw) / 2);
    var lh = size * 1.32;
    var startY = y + (h - lh * n) / 2 + lh / 2;
    if ('letterSpacing' in ctx) ctx.letterSpacing = prevLs;
    return { x: tl, y: startY - size / 2, w: tw, h: (n - 1) * lh + size };
  }
  function persUnion(a, b) {
    if (!a) return b; if (!b) return a;
    var x1 = Math.min(a.x, b.x), y1 = Math.min(a.y, b.y), x2 = Math.max(a.x + a.w, b.x + b.w), y2 = Math.max(a.y + a.h, b.y + b.h);
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
  }
  // The board's surface shade (white 10% at the top → black 6% at the bottom)
  // applied to a hex, for a given y on the board. The cleared panel behind the
  // printed text is painted AFTER that shade, so painting it flat made it read
  // brighter than the board's own white (#fafaf6 vs ~#ebebe8). Shading the
  // colour itself matches the board exactly without double-shading the band.
  function shadeBoardHex(hex, y, y0, outerH) {
    var h = String(hex || '#fafaf6').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var t = Math.max(0, Math.min(1, outerH ? (y - y0) / outerH : 0));
    var aw = 0.10 * (1 - t), ab = 0.06 * t;
    var out = [0, 2, 4].map(function (i) {
      var v = parseInt(h.substr(i, 2), 16);
      v = v * (1 - aw) + 255 * aw;   // white overlay
      v = v * (1 - ab);              // black overlay
      return Math.round(Math.max(0, Math.min(255, v)));
    });
    return '#' + out.map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
  }
  function drawPersonalisation(ctx, rect, ink, capPx, boxPadPx, boxHex) {
    var align = state.pers.align || 'center', lines = [state.pers.heading, state.pers.line2];
    var hasText = persHasText(), hasLogo = persHasLogo();
    if (!hasText && !hasLogo) return;
    // Content is drawn within an inset zone. The pad is a small physical mm value
    // (passed in) so the white box hugs the text rather than ballooning.
    var pad = boxPadPx || Math.min(rect.w, rect.h) * 0.10;
    var inner = { x: rect.x + pad, y: rect.y + pad, w: rect.w - pad * 2, h: rect.h - pad * 2 };
    if (inner.w <= 4 || inner.h <= 4) inner = { x: rect.x, y: rect.y, w: rect.w, h: rect.h };

    // Layout = alignment; logo (optional) stacks above OR below the text, same align.
    var logoZone = null, textZone = null;
    if (hasText && hasLogo) {
      var gap = inner.h * 0.06, logoH = inner.h * 0.42, textH = inner.h - logoH - gap;
      if (state.pers.logoPos === 'below') {
        textZone = { x: inner.x, y: inner.y, w: inner.w, h: textH };
        logoZone = { x: inner.x, y: inner.y + textH + gap, w: inner.w, h: logoH };
      } else {
        logoZone = { x: inner.x, y: inner.y, w: inner.w, h: logoH };
        textZone = { x: inner.x, y: inner.y + logoH + gap, w: inner.w, h: textH };
      }
    } else if (hasText) { textZone = inner; } else {
      // Logo only — cap its zone height (centred vertically) so a lone crest
      // doesn't balloon to fill the whole border. ~58% of the inset height keeps
      // it proportionate; full width retained so drawLogoFit honours alignment.
      var lh = inner.h * 0.58;
      logoZone = { x: inner.x, y: inner.y + (inner.h - lh) / 2, w: inner.w, h: lh };
    }

    // White backing box — ONLY over a pattern; hugs the content with equal padding.
    // On a plain board the content sits directly on the mount (ink follows the board).
    if (isPatterned()) {
      var b = null;
      if (logoZone) b = persUnion(b, persLogoRect(logoZone.x, logoZone.y, logoZone.w, logoZone.h, align));
      if (textZone) b = persUnion(b, persTextRect(ctx, textZone.x, textZone.y, textZone.w, textZone.h, align, capPx));
      if (b && b.w > 0 && b.h > 0) {
        var bx = Math.max(rect.x, b.x - pad), by = Math.max(rect.y, b.y - pad);
        var bw = Math.min(rect.x + rect.w, b.x + b.w + pad) - bx;
        var bh = Math.min(rect.y + rect.h, b.y + b.h + pad) - by;
        var br = Math.min(bw, bh) * 0.2;
        ctx.save();
        ctx.beginPath();
        if (ctx.roundRect) { ctx.roundRect(bx, by, bw, bh, br); } else { ctx.rect(bx, by, bw, bh); }
        // Backing box = the mount's own base colour (clears the pattern locally so
        // text stays legible) — NOT a brilliant-white label stuck on the mount.
        ctx.fillStyle = boxHex || boardBaseHex();
        ctx.fill();
        ctx.restore();
      }
      ink = persInk(); // dark ink on the light backing box
    }
    ctx.save();
    if (logoZone && state.pers.logoImg) drawLogoFit(ctx, state.pers.logoImg, logoZone.x, logoZone.y, logoZone.w, logoZone.h, align);
    if (textZone) drawTextBlock(ctx, lines, textZone.x, textZone.y, textZone.w, textZone.h, align, ink, capPx);
    ctx.restore();
  }
  // High-res transparent PNG of the personalisation (the printed artwork), at
  // board aspect, mirroring the preview's bottom-border placement.
  function renderPersExport() {
    lastPersRenderSpec = null;
    var d = boardDimsMm(state.variant); if (!d.w || !d.h) return null;
    var s = 2000 / d.w, W = Math.round(d.w * s), H = Math.round(d.h * s);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d');
    var apd = apertureDims();
    var apBottom = apd ? ((H + Math.min(apd.h * s, H * 0.92)) / 2) : (H * 0.60);
    var edge = PERS_EDGE_MM * s, gap = PERS_GAP_MM * s;
    var bandTop = apBottom + gap, bandBot = H - edge;
    var rect = persRect(0, W, bandTop, bandBot, s);
    if (rect.h < 8) return null;
    drawPersonalisation(ctx, rect, persInk(), persCapMm() * s, PERS_BOXPAD_MM * s);
    var r1 = function (n) { return Math.round(n * 10) / 10; };
    // Sent for fit-by-space designs, and ALWAYS for a logo design (the logo
    // can only reach the print file this way).
    lastPersRenderSpec = (pf().enabled || persHasLogo()) ? {
      v: 1,
      lines: [state.pers.heading, state.pers.line2],
      font: state.pers.font,
      align: state.pers.align || 'center',
      capMm: persCapMm(),
      exact: pf().enabled || undefined,
      inkHex: persInk(),
      boardWmm: r1(d.w), boardHmm: r1(d.h),
      bandMm: { x: r1(rect.x / s), y: r1(rect.y / s), w: r1(rect.w / s), h: r1(rect.h / s) },
      boxPadMm: PERS_BOXPAD_MM,
      patterned: isPatterned(),
      mountBaseHex: boardBaseHex()
    } : null;
    return cv.toDataURL('image/png');
  }
  // Uploads the rendered overlay and, for a logo design, the ORIGINAL logo file:
  // the print-file app redraws the logo from it (the overlay is screen-res), and
  // without it every logo was dropped from the print file.
  function uploadPersImage(dataUrl) {
    var key = uploadKey('personalisation.png');
    var jobs = [uploadOne(dataUrl, key)];
    var logoKey = null;
    if (persHasLogo() && state.pers.logoDataUrl) {
      logoKey = uploadKey('personalisation-logo' + (/^data:image\/png/i.test(state.pers.logoDataUrl) ? '.png' : '.jpg'));
      jobs.push(uploadOne(state.pers.logoDataUrl, logoKey));
    }
    return Promise.all(jobs).then(function () {
      var logoUrl = logoKey ? publicS3Url(logoKey) : null;
      if (logoUrl && lastPersRenderSpec) lastPersRenderSpec.logo = { url: logoUrl, pos: state.pers.logoPos || 'above' };
      return { url: publicS3Url(key), logoUrl: logoUrl };
    });
  }
  function loadPersLogoFile(file) {
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.pers.logoDataUrl = e.target.result;
      var img = new Image();
      img.onload = function () {
        state.pers.logoImg = img;
        if (elPersLogoDrop) elPersLogoDrop.dataset.hasImage = 'true';
        if (elPersLogoThumb) elPersLogoThumb.style.backgroundImage = 'url("' + state.pers.logoDataUrl + '")';
        if (elPersLogoTitle) elPersLogoTitle.textContent = 'Logo added — click to replace';
        refreshPrice(); // a logo can satisfy persHasContent (e.g. logo-only) → premium
        renderPreview();
      };
      img.src = state.pers.logoDataUrl;
    };
    reader.readAsDataURL(file);
  }

  /* ---------- Personalisation UI ---------- */
  function setPersFontValue() {
    if (!elPersFontValue) return;
    elPersFontValue.textContent = state.pers.font;
    elPersFontValue.style.fontFamily = fontFamilyCss(state.pers.font);
  }
  function renderPersFonts() {
    if (!elPersFontList) return;
    elPersFontList.innerHTML = '';
    PERS_FONTS.forEach(function (f) {
      var li = document.createElement('li');
      li.className = 'pfc-moulding__select-option';
      li.setAttribute('role', 'option');
      li.dataset.font = f;
      li.textContent = f;
      li.style.fontFamily = fontFamilyCss(f);
      li.setAttribute('aria-selected', f === state.pers.font ? 'true' : 'false');
      li.addEventListener('click', function () {
        state.pers.font = f;
        Array.from(elPersFontList.children).forEach(function (o) {
          o.setAttribute('aria-selected', o.dataset.font === f ? 'true' : 'false');
        });
        setPersFontValue();
        setPersFontOpen(false);
        renderPreview();
      });
      elPersFontList.appendChild(li);
    });
    setPersFontValue();
  }
  function setPersFontOpen(open) {
    if (!elPersFontList || !elPersFontTrigger) return;
    elPersFontList.hidden = !open;
    elPersFontTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (elPersFontSelect) elPersFontSelect.classList.toggle('is-open', open);
  }
  // Logo is an optional toggle; reveal the position + upload controls when on.
  function updateLogoFields() {
    if (elPersLogoFields) elPersLogoFields.hidden = !state.pers.logoOn;
  }
  function loadPersFonts() {
    if (!document.fonts || !document.fonts.load) return;
    PERS_FONTS.forEach(function (f) { try { document.fonts.load('600 32px "' + f + '"'); } catch (_) {} });
    if (document.fonts.ready) document.fonts.ready.then(function () { renderPreview(); });
  }

  /* ---------- Canvas preview ---------- */
  function drawScaleWall(ctx, W, H, floorYpx) {
    var wall = ctx.createLinearGradient(0, 0, 0, floorYpx);
    wall.addColorStop(0, '#efe7d8'); wall.addColorStop(1, '#e6dcc9');
    ctx.fillStyle = wall; ctx.fillRect(0, 0, W, floorYpx);
    var floor = ctx.createLinearGradient(0, floorYpx, 0, H);
    floor.addColorStop(0, '#d9ccb4'); floor.addColorStop(1, '#cdbfa3');
    ctx.fillStyle = floor; ctx.fillRect(0, floorYpx, W, H - floorYpx);
    ctx.strokeStyle = 'rgba(120,100,70,0.22)';
    ctx.lineWidth = Math.max(1, H * 0.004);
    ctx.beginPath(); ctx.moveTo(0, floorYpx); ctx.lineTo(W, floorYpx); ctx.stroke();
  }

  function drawPerson(ctx, cx, baseY, hpx) {
    var h = hpx;
    ctx.save();
    ctx.fillStyle = 'rgba(60,45,25,0.16)';
    ctx.beginPath(); ctx.ellipse(cx, baseY, h * 0.13, h * 0.012, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(74,62,48,0.55)';
    var headR = h * 0.052, headCy = baseY - h + headR;
    ctx.beginPath(); ctx.arc(cx, headCy, headR, 0, Math.PI * 2); ctx.fill();
    var shoulderY = headCy + headR * 1.5, shoulderW = h * 0.1, hipW = h * 0.075;
    var hipY = baseY - h * 0.46, footY = baseY, legGap = h * 0.016;
    ctx.beginPath();
    ctx.moveTo(cx - shoulderW, shoulderY);
    ctx.quadraticCurveTo(cx - shoulderW * 1.04, (shoulderY + hipY) / 2, cx - hipW, hipY);
    ctx.lineTo(cx - hipW, footY); ctx.lineTo(cx - legGap, footY);
    ctx.lineTo(cx - legGap, hipY + h * 0.012); ctx.lineTo(cx + legGap, hipY + h * 0.012);
    ctx.lineTo(cx + legGap, footY); ctx.lineTo(cx + hipW, footY); ctx.lineTo(cx + hipW, hipY);
    ctx.quadraticCurveTo(cx + shoulderW * 1.04, (shoulderY + hipY) / 2, cx + shoulderW, shoulderY);
    ctx.closePath(); ctx.fill();
    ctx.restore();
  }

  // True-to-order board render for the cart drawer + the print-file admin app:
  // the board at its REAL aspect, in the chosen pattern AND the chosen colour,
  // with the opening cut where it will be cut.
  //
  // Why it exists: `_addon_bundle_pro_image` must be a Shopify-CDN URL (an S3 one
  // rejects the whole cart-transform — see the guard in postCart), so the Bundle
  // Pro line image can only ever be a pre-baked swatch file. Those swatches are
  // keyed by pattern STYLE, and their colour is whatever they were baked in — so
  // a sage order showed a navy tile in the admin and the mounter cut to it
  // (US order PFC-1332049). This render rides on `_pfc_cart_image` / `Board
  // preview`, plain properties the function never reads, so it is safe.
  //
  // NOT a print file: it has the aperture punched out and is ~900px. The
  // printable board (full bleed, no opening, 300dpi) is generated from the order
  // by the print-file admin app — src/lib/services/mount-print.ts.
  function renderLineImage() {
    var board = boardDimsMm(state.variant);
    if (!board.w || !board.h) return null;
    var MAX = 900;
    var scale = MAX / Math.max(board.w, board.h);
    var W = Math.max(2, Math.round(board.w * scale));
    var H = Math.max(2, Math.round(board.h * scale));
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d');
    if (!ctx) return null;

    ctx.fillStyle = boardBaseHex();
    ctx.fillRect(0, 0, W, H);
    paintBoardPattern(ctx, 0, 0, W, H, scale, board.w, board.h);

    var apd = apertureDims();
    if (apd) {
      var apW = Math.min(apd.w * scale, W * 0.96), apH = Math.min(apd.h * scale, H * 0.96);
      var apX = (W - apW) / 2, apY = (H - apH) / 2;
      // Accent reveal is printed on the FACE, outside the opening — draw it
      // before the window so the window edge clips nothing.
      if (isAccent()) {
        var gap = Math.max(2, (state.colour.gapMm || 10) * scale);
        var lw = Math.max(1, (state.colour.lineMm || 1.4) * scale);
        if (apX - gap > 1 && apY - gap > 1) {
          ctx.strokeStyle = state.stripeColour;
          ctx.lineWidth = lw;
          ctx.strokeRect(apX - gap, apY - gap, apW + gap * 2, apH + gap * 2);
        }
      }
      if (state.userImg) {
        drawImageCover(ctx, state.userImg, apX, apY, apW, apH);
      } else {
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(apX, apY, apW, apH);
      }
      ctx.strokeStyle = 'rgba(0,0,0,0.28)';
      ctx.lineWidth = 1;
      ctx.strokeRect(apX + 0.5, apY + 0.5, apW - 1, apH - 1);
    }

    // Printed text/logo sits in the bottom border — include it so the cart image
    // shows the finished board, matching the on-page preview.
    if (isPersActive()) {
      var apBottom = apd ? ((H + Math.min(apd.h * scale, H * 0.96)) / 2) : (H * 0.60);
      var edge = PERS_EDGE_MM * scale, pgap = PERS_GAP_MM * scale;
      var pRect = persRect(0, W, apBottom + pgap, H - edge, scale);
      if (pRect.h > 8 && pRect.w > 8) drawPersonalisation(ctx, pRect, persInk(), persCapMm() * scale, PERS_BOXPAD_MM * scale);
    }

    ctx.strokeStyle = state.colour.border || 'rgba(0,0,0,0.12)';
    ctx.lineWidth = 1;
    ctx.strokeRect(0.5, 0.5, W - 1, H - 1);
    return c.toDataURL('image/jpeg', 0.86);
  }

  // Board pattern fill — the ONLY implementation, shared by the on-screen
  // preview (renderPreview) and the cart/admin line-image render
  // (renderLineImage). Paints the pattern over an already-filled base; the
  // aperture window is drawn on top by the caller. `scale` is px per mm.
  function paintBoardPattern(ctx, x0, y0, outerW, outerH, scale, boardW_mm, boardH_mm) {
    // ----- Vertical stripes (drawn pattern) -----
    // 19 equal bands across the board width: base/colour alternating, base first
    // from the left → 10 base + 9 coloured. Aperture window draws on top, so the
    // pattern reads on the visible mount border.
    if (isStripes()) {
      var horiz = state.colour.orient === 'h';
      var nBands = stripeBandCount(horiz ? boardH_mm : boardW_mm);
      if (horiz) {
        var bandH = outerH / nBands;
        for (var bi = 0; bi < nBands; bi++) {
          ctx.fillStyle = (bi % 2 === 0) ? STRIPE_BASE_HEX : state.stripeColour;
          ctx.fillRect(x0, y0 + bi * bandH, outerW, Math.ceil(bandH) + 1);
        }
      } else {
        var bandW = outerW / nBands;
        for (var bj = 0; bj < nBands; bj++) {
          ctx.fillStyle = (bj % 2 === 0) ? STRIPE_BASE_HEX : state.stripeColour;
          // +1px overlap avoids hairline seams from sub-pixel band widths.
          ctx.fillRect(x0 + bj * bandW, y0, Math.ceil(bandW) + 1, outerH);
        }
      }
    } else if (isGingham()) {
      // Two passes of semi-transparent bands (V + H); overlaps read darkest.
      var gcell = Math.max(6, (state.colour.cellMm || 16) * scale);
      ctx.save();
      ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.fillStyle = state.stripeColour; ctx.globalAlpha = 0.42;
      var gcols = Math.ceil(outerW / gcell), grows = Math.ceil(outerH / gcell);
      for (var gx = 0; gx < gcols; gx += 2) ctx.fillRect(x0 + gx * gcell, y0, Math.ceil(gcell) + 1, outerH);
      for (var gy = 0; gy < grows; gy += 2) ctx.fillRect(x0, y0 + gy * gcell, outerW, Math.ceil(gcell) + 1);
      ctx.globalAlpha = 1; ctx.restore();
    } else if (isPolka()) {
      var pcell = Math.max(8, (state.colour.dotMm || 18) * scale);
      var pr = pcell * 0.3;
      ctx.save();
      ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.fillStyle = state.stripeColour;
      var prows = Math.ceil(outerH / pcell) + 1, pcols = Math.ceil(outerW / pcell) + 1;
      for (var pry = 0; pry < prows; pry++) {
        for (var pcx = 0; pcx < pcols; pcx++) {
          var ox = x0 + pcx * pcell + (pry % 2 ? pcell / 2 : 0) + pcell / 2;
          var oy = y0 + pry * pcell + pcell / 2;
          ctx.beginPath(); ctx.arc(ox, oy, pr, 0, Math.PI * 2); ctx.fill();
        }
      }
      ctx.restore();
    } else if (isChevron()) {
      // Repeating zigzag strokes (V shapes) across the board.
      var amp = Math.max(5, (state.colour.bandMm || 14) * scale);
      ctx.save();
      ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.strokeStyle = state.stripeColour; ctx.lineWidth = Math.max(2, amp * 0.5); ctx.lineCap = 'butt';
      for (var cyy = y0 - outerH; cyy < y0 + outerH * 2; cyy += amp * 2) {
        ctx.beginPath();
        var up = true;
        for (var cxx = x0; cxx <= x0 + outerW + amp; cxx += amp) {
          var cpy = cyy + (up ? 0 : amp);
          if (cxx === x0) ctx.moveTo(cxx, cpy); else ctx.lineTo(cxx, cpy);
          up = !up;
        }
        ctx.stroke();
      }
      ctx.restore();
    } else if (isCheckers()) {
      // Checkerboard: set-width squares, coloured cells on the white base.
      var cell = Math.max(6, (state.colour.checkMm || 24) * scale);
      var cols = Math.ceil(outerW / cell), rows = Math.ceil(outerH / cell);
      ctx.save();
      ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.fillStyle = state.stripeColour;
      for (var ry = 0; ry < rows; ry++) {
        for (var cxn = 0; cxn < cols; cxn++) {
          if ((cxn + ry) % 2 === 0) continue;
          ctx.fillRect(x0 + cxn * cell, y0 + ry * cell, Math.ceil(cell) + 1, Math.ceil(cell) + 1);
        }
      }
      ctx.restore();
    } else if (isPattern() && state.patternImg) {
      // Uploaded pattern: scale to the board WIDTH, crop vertically central.
      // Fall back to height-cover if width-scaling would leave vertical gaps.
      ctx.save();
      ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      var pim = state.patternImg;
      var ps = outerW / pim.width, pdh = pim.height * ps;
      if (pdh < outerH) { ps = outerH / pim.height; pdh = outerH; }
      var pdw = pim.width * ps;
      ctx.drawImage(pim, x0 + (outerW - pdw) / 2, y0 + (outerH - pdh) / 2, pdw, pdh);
      ctx.restore();
    }
  }

  function renderPreview() {
    // Size / opening / orientation all land here, so this is the one place that
    // sees the opening ratio move under a confirmed crop.
    if (cropAspectDrifted()) scheduleRecrop();
    // Size / opening / orientation all land here — re-test the printed-text fit
    // before drawing so the add-on blocks the moment the border goes too narrow.
    updatePersFit();
    pf().update();
    if (!elCanvas) return;
    var ctx = elCanvas.getContext('2d');
    if (!ctx) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.max(320, Math.round(elCanvas.clientWidth || elCanvas.getBoundingClientRect().width));
    var H = Math.max(320, Math.round(elCanvas.clientHeight || elCanvas.getBoundingClientRect().height));
    var BW = W * dpr, BH = H * dpr;
    if (elCanvas.width !== BW || elCanvas.height !== BH) { elCanvas.width = BW; elCanvas.height = BH; }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);

    var board = boardDimsMm(state.variant);
    if (!board.w || !board.h) return;
    var boardW_mm = board.w, boardH_mm = board.h;

    var scaleScene = state.scene === 'scale';
    var scale, outerW, outerH, x0, y0, floorY;

    if (scaleScene) {
      var PADpx = 26;
      var PERSON_H = 1680, PERSON_W = 520, GAP = 260, CENTRE = 1300;
      var topNeeded = Math.max(PERSON_H, CENTRE + boardH_mm / 2) + 130;
      var sceneW_mm = PERSON_W + GAP + boardW_mm;
      var sceneH_mm = topNeeded + 70;
      scale = Math.min((W - PADpx * 2) / sceneW_mm, (H - PADpx * 2) / sceneH_mm);
      var sceneWpx = sceneW_mm * scale, sceneHpx = sceneH_mm * scale;
      var originX = (W - sceneWpx) / 2;
      floorY = (H + sceneHpx) / 2 - 70 * scale;
      outerW = boardW_mm * scale; outerH = boardH_mm * scale;
      var bcx = originX + (PERSON_W + GAP + boardW_mm / 2) * scale;
      var bcy = floorY - CENTRE * scale;
      x0 = bcx - outerW / 2; y0 = bcy - outerH / 2;
      drawScaleWall(ctx, W, H, floorY);
      drawPerson(ctx, originX + (PERSON_W / 2) * scale, floorY, PERSON_H * scale);
      ctx.fillStyle = 'rgba(74,62,48,0.6)';
      ctx.font = '600 12px ' + UI_FONT;
      ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
      ctx.fillText('Shown to scale · person ≈ 1.7 m', W / 2, H - 12);
    } else {
      var bg = ctx.createLinearGradient(0, 0, 0, H);
      bg.addColorStop(0, '#f9f4ec'); bg.addColorStop(1, '#f1e9da');
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
      // Board occupies ~78% of the stage's limiting dimension (mirrors the
      // moulding customiser's MARGIN, so the preview stays a sensible size in
      // the viewport instead of filling edge-to-edge).
      var MARGIN = 0.78;
      scale = Math.min(W / boardW_mm, H / boardH_mm) * MARGIN;
      outerW = boardW_mm * scale; outerH = boardH_mm * scale;
      x0 = (W - outerW) / 2; y0 = (H - outerH) / 2;
    }

    // ----- Board drop shadow + fill -----
    ctx.save();
    ctx.shadowColor = scaleScene ? 'rgba(40,28,12,0.34)' : 'rgba(60,45,25,0.20)';
    ctx.shadowBlur = scaleScene ? 32 : 24;
    ctx.shadowOffsetX = scaleScene ? 2 : 2;
    ctx.shadowOffsetY = scaleScene ? 18 : 12;
    ctx.fillStyle = boardBaseHex();
    ctx.fillRect(x0, y0, outerW, outerH);
    ctx.restore();

    paintBoardPattern(ctx, x0, y0, outerW, outerH, scale, boardW_mm, boardH_mm);

    // Surface shade so a light board reads against the light backdrop.
    var surf = ctx.createLinearGradient(x0, y0, x0, y0 + outerH);
    surf.addColorStop(0, 'rgba(255,255,255,0.10)');
    surf.addColorStop(1, 'rgba(0,0,0,0.06)');
    ctx.fillStyle = surf;
    ctx.fillRect(x0, y0, outerW, outerH);

    // Outer board edge.
    ctx.strokeStyle = state.colour.border || 'rgba(0,0,0,0.12)';
    ctx.lineWidth = 1;
    ctx.strokeRect(x0 + 0.5, y0 + 0.5, outerW - 1, outerH - 1);

    // ----- Aperture window (bevel cut) -----
    var apd = apertureDims();
    if (apd) {
      var apW = apd.w * scale, apH = apd.h * scale;
      // Clamp so the window can't exceed the board (defensive).
      apW = Math.min(apW, outerW * 0.92);
      apH = Math.min(apH, outerH * 0.92);
      var apX = x0 + (outerW - apW) / 2;
      var apY = y0 + (outerH - apH) / 2;

      // Bevel band width scales with board size; the 45° cut reveals the white
      // core, so the band runs lighter than the surface as it angles inward.
      var bevel = Math.max(2, Math.min(outerW, outerH) * 0.011);

      // Photo (or empty paper) sits inside the bevel.
      var inX = apX + bevel, inY = apY + bevel;
      var inW = Math.max(2, apW - bevel * 2), inH = Math.max(2, apH - bevel * 2);

      // Bevel ring — drawn as the board-colour aperture with a white core
      // gradient on each of the four chamfers.
      drawBevel(ctx, apX, apY, apW, apH, bevel, state.colour);

      // Inner window: photo preview or empty paper.
      if (state.userImg) {
        drawImageCover(ctx, state.userImg, inX, inY, inW, inH);
      } else {
        var paper = ctx.createLinearGradient(inX, inY, inX, inY + inH);
        paper.addColorStop(0, '#ffffff'); paper.addColorStop(1, '#f4f1ea');
        ctx.fillStyle = paper;
        ctx.fillRect(inX, inY, inW, inH);
        ctx.fillStyle = 'rgba(74,62,48,0.34)';
        ctx.font = '600 ' + Math.max(11, inW * 0.05) + 'px ' + UI_FONT;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Your print sits here', inX + inW / 2, inY + inH / 2);
      }
      // Inner aperture shadow line.
      ctx.strokeStyle = 'rgba(0,0,0,0.30)';
      ctx.lineWidth = 1;
      ctx.strokeRect(inX + 0.5, inY + 0.5, inW - 1, inH - 1);

      // Accent reveal: a thin printed keyline on the mount FACE, offset out from
      // the opening (we print on the face only — no physical under-mount).
      if (isAccent()) {
        var gap = Math.max(3, (state.colour.gapMm || 10) * scale);
        var lw = Math.max(1, (state.colour.lineMm || 1.4) * scale);
        var lx = apX - gap, ly = apY - gap, lwd = apW + gap * 2, lht = apH + gap * 2;
        if (lx > x0 + 2 && ly > y0 + 2) {       // keep the line on the board
          ctx.strokeStyle = state.stripeColour;
          ctx.lineWidth = lw;
          ctx.strokeRect(lx, ly, lwd, lht);
        }
      }
    } else {
      // No aperture defined — show plain board with a hint.
      ctx.fillStyle = 'rgba(74,62,48,0.30)';
      ctx.font = '600 13px ' + UI_FONT;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Select an opening size', x0 + outerW / 2, y0 + outerH / 2);
    }

    // ----- Printed personalisation (text / logo) in the bottom border -----
    if (isPersActive()) {
      var apBottomPx = apd
        ? (y0 + (outerH + Math.min(apd.h * scale, outerH * 0.92)) / 2)
        : (y0 + outerH * 0.60);
      var edge = PERS_EDGE_MM * scale, gap = PERS_GAP_MM * scale;
      var bandTop = apBottomPx + gap, bandBot = (y0 + outerH) - edge;
      var pRect = persRect(x0, outerW, bandTop, bandBot, scale);
      if (pRect.h > 8 && pRect.w > 8) {
        drawPersonalisation(ctx, pRect, persInk(), persCapMm() * scale, PERS_BOXPAD_MM * scale,
          shadeBoardHex(boardBaseHex(), pRect.y + pRect.h / 2, y0, outerH));
      }
      var bpad = PERS_BOXPAD_MM * scale;
      syncPersSizeSteps(pRect.w - bpad * 2, pRect.h - bpad * 2, scale);
    }
  }

  // Draws the 45° bevel chamfer as four trapezoids, each a gradient from the
  // board surface (outer) to the lighter white core (inner edge).
  function drawBevel(ctx, x, y, w, h, b, colour) {
    var surface = colour.hex || '#fafaf6';
    var core = '#ffffff';
    var ox1 = x, oy1 = y, ox2 = x + w, oy2 = y + h;
    var ix1 = x + b, iy1 = y + b, ix2 = x + w - b, iy2 = y + h - b;

    function chamfer(p1, p2, p3, p4, light) {
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]);
      ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]);
      ctx.closePath();
      var g = ctx.createLinearGradient(p1[0], p1[1], p4[0], p4[1]);
      g.addColorStop(0, surface);
      g.addColorStop(1, core);
      ctx.fillStyle = g;
      ctx.fill();
      // Subtle directional shading so adjacent chamfers read as a 3D cut.
      ctx.fillStyle = light;
      ctx.fill();
      ctx.restore();
    }
    // Top, bottom, left, right chamfers. Light values give a top-left light.
    chamfer([ox1, oy1], [ox2, oy1], [ix2, iy1], [ix1, iy1], 'rgba(255,255,255,0.14)'); // top
    chamfer([ox1, oy2], [ox2, oy2], [ix2, iy2], [ix1, iy2], 'rgba(0,0,0,0.10)');       // bottom
    chamfer([ox1, oy1], [ox1, oy2], [ix1, iy2], [ix1, iy1], 'rgba(255,255,255,0.08)'); // left
    chamfer([ox2, oy1], [ox2, oy2], [ix2, iy2], [ix2, iy1], 'rgba(0,0,0,0.06)');       // right
  }

  function drawImageCover(ctx, img, dx, dy, dw, dh) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.max(dw / iw, dh / ih);
    var rw = iw * s, rh = ih * s;
    var sx = (rw - dw) / 2 / s, sy = (rh - dh) / 2 / s;
    ctx.save();
    ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
    ctx.drawImage(img, sx, sy, dw / s, dh / s, dx, dy, dw, dh);
    ctx.restore();
  }

  /* ---------- Upload / crop (preview only) ---------- */
  function setUploadOpen(open) {
    // Panel = the accordion body (matches the printed-text/logo "Extra" UX);
    // fall back to the dropzone itself if the panel wrapper isn't present.
    var panel = elUploadPanel || elUpload;
    if (panel) panel.hidden = !open;
  }

  function openCropperWithUrl(url) {
    // Hold a decoded copy of the ORIGINAL. Cropper owns elCropImg and tears it
    // down on close, and the object URL dies with the tab — without this there
    // is nothing left to re-cut from when the opening ratio changes later.
    if (!state.srcImg || state.srcImg.src !== url) {
      var si = new Image();
      // Only if this is still the photo in play — a cancelled pick must not land.
      si.onload = function () { if (state.originalUrl === url) { state.srcImg = si; state.cropStale = false; } };
      si.src = url;
    }
    // A file the browser can't decode never fires load: without this the cropper
    // sat open and blank. Close it, put the previous photo back and say why. The
    // stale load listener of a failed open disarms itself on the next load.
    var failed = false;
    elCropImg.onerror = function () {
      elCropImg.onerror = null;
      failed = true;
      if (state.originalUrl !== url) return;
      cancelCrop();
      uploadNotice('We couldn’t open that file. Please use a JPG, PNG, HEIC or PDF.', 'error');
    };
    elCropImg.src = url;
    elCropModal.dataset.open = 'true';
    elCropImg.addEventListener('load', function once() {
      elCropImg.removeEventListener('load', once);
      if (failed) return;
      elCropImg.onerror = null;
      if (state.cropper) { try { state.cropper.destroy(); } catch (_) {} }
      if (typeof Cropper === 'undefined') {
        state.previewDataUrl = url;
        commitPhoto();
        applyPreview();
        closeCropper();
        return;
      }
      var opts = {
        aspectRatio: currentAspectRatio(),
        viewMode: 1, autoCropArea: 1, responsive: true,
        background: false, zoomable: true, movable: true,
      };
      if (state.cropData) {
        var saved = state.cropData;
        opts.ready = function () { try { state.cropper.setData(saved); } catch (_) {} };
      }
      state.cropper = new Cropper(elCropImg, opts);
    });
  }

  function openCropper(file) {
    var UN = window.PFCUploadNormalise;
    if (UN && UN.needsConversion(file)) {
      // HEIC / PDF → JPEG first; the converted file re-enters as a plain JPEG.
      uploadNotice(UN.busyText(file), 'busy');
      UN.normalise(file).then(function (r) { uploadNotice(r.note || '', 'info'); openCropper(r.file); },
        function (err) { uploadNotice(err.message, 'error'); });
      return;
    }
    if (photoSrc && !photoSrc.start(file)) {
      uploadNotice('That photo is over ' + Math.round(window.PFCPhotoSource.MAX_BYTES / 1048576) + 'MB — please choose a smaller file.', 'error');
      return;
    }
    flashStatus('');   // a previous upload error no longer applies
    // Provisional until Confirm: keep what was confirmed before so Cancel can put
    // it back (see cancelCrop). A second pick before confirming keeps the first
    // stash — Cancel always returns to the last CONFIRMED photo.
    if (!state.pendingPrev) {
      state.pendingPrev = { originalUrl: state.originalUrl, cropData: state.cropData, srcImg: state.srcImg };
    } else if (state.originalUrl) {
      try { URL.revokeObjectURL(state.originalUrl); } catch (_) {}
    }
    var url = URL.createObjectURL(file);
    state.originalUrl = url;
    state.cropData = null;
    state.srcImg = null;
    openCropperWithUrl(url);
  }

  // The crop on screen now belongs to the photo being uploaded.
  function commitPhoto() {
    var p = state.pendingPrev;
    state.pendingPrev = null;
    if (p && p.originalUrl && p.originalUrl !== state.originalUrl) {
      try { URL.revokeObjectURL(p.originalUrl); } catch (_) {}
    }
    if (photoSrc) { photoSrc.commit(); state.cropFor = photoSrc.state().url; }
  }

  function cancelCrop() {
    var p = state.pendingPrev;
    if (p) {
      state.pendingPrev = null;
      if (state.originalUrl && state.originalUrl !== p.originalUrl) {
        try { URL.revokeObjectURL(state.originalUrl); } catch (_) {}
      }
      state.originalUrl = p.originalUrl; state.cropData = p.cropData; state.srcImg = p.srcImg;
      if (photoSrc) photoSrc.revert();
    }
    closeCropper();
  }

  function reopenCropper() {
    if (!state.originalUrl) return;
    openCropperWithUrl(state.originalUrl);
  }

  function confirmCrop() {
    if (!state.cropper) { closeCropper(); return; }
    try { state.cropData = state.cropper.getData(true); } catch (_) { state.cropData = null; }
    // fillColor flattens transparency onto white before the JPEG encode (JPEG has
    // no alpha → a transparent PNG would otherwise render black).
    var previewCanvas = state.cropper.getCroppedCanvas({
      maxWidth: 900, maxHeight: 900, fillColor: '#ffffff', imageSmoothingQuality: 'medium',
    });
    state.previewDataUrl = previewCanvas.toDataURL('image/jpeg', 0.85);
    // No full-resolution encode: the print is cut from the uploaded original.
    state.croppedAspect = currentAspectRatio();
    state.cropStale = false;
    commitPhoto();
    applyPreview();
    closeCropper();
  }

  /*
   * Reshape the crop when the OPENING RATIO changes under a crop that is
   * already confirmed — an orientation flip, a new size, or a hand-typed
   * opening. Otherwise the order's `Orientation` (computed live at add-to-cart)
   * and the crop (frozen at Confirm) disagree, and the canvas preview hides
   * it by cover-cropping the stale JPEG into the new opening. See the same fix
   * in pfc-print-app.js, and order PFC-UK-1338458.
   */
  function cropToDataUrl(img, box, maxPx, q) {
    var s = Math.min(1, maxPx / Math.max(box.width, box.height));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(box.width * s));
    c.height = Math.max(1, Math.round(box.height * s));
    var ctx = c.getContext('2d');
    if (!ctx) return null;
    ctx.imageSmoothingQuality = 'high';
    // JPEG has no alpha — flatten onto white exactly as confirmCrop's fillColor does.
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, box.x, box.y, box.width, box.height, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', q);
  }
  // Re-cut off the back of a short debounce: a typed size or a dragged opening
  // fires renderPreview on every keystroke, and a canvas encode per keystroke
  // would stutter. The on-canvas preview is already correct meanwhile
  // (it cover-crops), and add-to-cart re-checks, so nothing escapes on the gap.
  var recropTimer = null;
  function scheduleRecrop() {
    if (recropTimer) clearTimeout(recropTimer);
    recropTimer = setTimeout(function () {
      recropTimer = null;
      if (!cropAspectDrifted()) return;
      if (recropToAspect()) applyPreview();
      else state.cropStale = true;   // original gone (reload) — add-to-cart will ask
    }, 150);
  }

  function recropToAspect() {
    var img = state.srcImg, d = state.cropData, ar = currentAspectRatio();
    if (!img || !img.naturalWidth || !d || !d.width || !d.height || !ar) return false;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    // Keep the crop's height and reshape the width to the new ratio, shrinking
    // to fit when that runs past an edge.
    var nh = Math.min(d.height, ih), nw = nh * ar;
    if (nw > iw) { nw = iw; nh = nw / ar; }
    if (nh > ih) { nh = ih; nw = nh * ar; }
    var cx = d.x + d.width / 2, cy = d.y + d.height / 2;
    var box = {
      x: Math.max(0, Math.min(iw - nw, cx - nw / 2)),
      y: Math.max(0, Math.min(ih - nh, cy - nh / 2)),
      width: nw, height: nh,
    };
    var prev = cropToDataUrl(img, box, 900, 0.85);
    if (!prev) return false;
    state.cropData = box;
    state.previewDataUrl = prev;
    state.croppedAspect = ar;
    state.cropStale = false;
    return true;
  }
  // True when the confirmed crop no longer matches the opening ratio.
  function cropAspectDrifted() {
    var ar = currentAspectRatio();
    return !!(state.previewDataUrl && state.croppedAspect && ar
      && Math.abs(state.croppedAspect - ar) > 0.001);
  }

  function closeCropper() {
    elCropModal.dataset.open = 'false';
    if (state.cropper) { try { state.cropper.destroy(); } catch (_) {} state.cropper = null; }
    elCropImg.src = '';
  }

  function applyPreview() {
    if (elUpload) elUpload.dataset.hasImage = 'true';
    setUploadOpen(true);
    if (elPreview) elPreview.dataset.hasImage = 'true';
    if (elUploadTitle) elUploadTitle.textContent = 'Looking good — Recrop or Replace below';
    if (elAddPhoto) elAddPhoto.checked = true;
    var img = new Image();
    img.onload = function () { state.userImg = img; renderPreview(); updatePrintPrice(); };
    img.src = state.previewDataUrl;
  }

  function currentAspectRatio() {
    var d = apertureDims();
    if (d) return d.w / d.h;
    var bd = boardDimsMm(state.variant);
    return bd.w ? (bd.w / bd.h) : 1;
  }

  /* ---------- Print-for-me ---------- */
  function printConfig() { return cfg.print || {}; }
  function printAvailable() { return !!(printConfig().available && printConfig().customVariantId); }

  // The printed photo = the opening (window) the customer's image sits in.
  function printOpeningMm() {
    var d = apertureDims();
    return (d && d.w && d.h) ? { w: d.w, h: d.h } : null;
  }
  // Roll-fed limit: when we print the photo, the opening becomes the print and
  // must fit the roll — shorter side ≤ maxShort (24"/610mm), longer ≤ maxLong
  // (1300mm). Only applies in print-for-me mode (a customer's own print is not
  // produced by us, so it isn't roll-constrained).
  // Upload-independent roll check, so the price/headline can react to the opening
  // before any file is chosen (isPrintMode() needs state.userImg).
  function printRollTooLarge() {
    var o = printOpeningMm(); if (!o) return false;
    var P = printConfig(), maxShort = P.maxShortMm || 610, maxLong = P.maxLongMm || 1300;
    return Math.min(o.w, o.h) > maxShort || Math.max(o.w, o.h) > maxLong;
  }
  function printRollError() {
    if (!isPrintMode()) return null;
    if (!printOpeningMm() || !printRollTooLarge()) return null;
    var P = printConfig(), maxShort = P.maxShortMm || 610, maxLong = P.maxLongMm || 1300;
    return 'Opening too large to print — we print up to ' + fmtSide(maxShort) + ' on the shorter side and ' + fmtSide(maxLong) + ' on the longer side.';
  }

  function printPriceValue() {
    var o = printOpeningMm(); if (!o) return null;
    var P = printConfig();
    var gbp = Math.round(Math.max(6, (o.w * o.h) / 1e6 * (P.ppsqm || 128.27)) * 4) / 4;
    if (P.usd) return Math.max(P.floor || 10, Math.ceil(gbp / 0.72 * 1.30));
    return gbp;
  }

  // The custom-print product is a SEPARATE Bundle Pro host with its own base, so
  // its ladder converts on its own multiple. Using the mount's here would quote
  // a print price the print line never charges.
  function printRate() {
    var P = printConfig();
    if (window.PFCBundleRate) return window.PFCBundleRate(Number(P.base) * 100, P.hostBase);
    return bundleRate(state.variant);
  }
  function matchPrintBucket(value) {
    var ladder = printConfig().ladder || [];
    // Bundle Pro adds bucket.price ON TOP of the custom-print host base, so the
    // ladder stores the UPCHARGE. Charged total = base + upcharge; match the raw
    // absolute print price against that.
    // `value` is base currency; `base` (Liquid variant price) is presentment.
    var base = Number(printConfig().base || 0);
    var target = value * printRate();
    var best = null, bestUp = Infinity;
    ladder.forEach(function (b) {
      var up = addonChargeMajor(b.price, printRate());
      if ((up + base) >= target - 1e-9 && (up < bestUp || (up === bestUp && b.price < best.price))) { best = b; bestUp = up; }
    });
    return best || (ladder.length ? ladder[ladder.length - 1] : null);
  }

  // Adding a photo = "print it for me". No preview-only option: if the buyer
  // has ticked Add-a-photo and uploaded an image (and we can size + price the
  // print), we print it and add the custom-print line at checkout.
  function isPrintMode() {
    return !!(elAddPhoto && elAddPhoto.checked) && printAvailable() &&
           state.userImg && !!printOpeningMm() && printPriceValue() != null;
  }

  // CUSTOM SIZE ONLY: the photo is ABSORBED into the mount's own ladder bucket —
  // one physical item (mat + mounted photo) = one cart line, one price. Fixed
  // sizes have no ladder to absorb into, so they keep the legacy second
  // (custom-print) line — see docs/MOUNT-PHOTO-ABSORB-SCOPE.md.
  // Does this variant's ladder actually REACH `raw`? If not, absorbing would make
  // matchBucket clamp to the top bucket and UNDERCHARGE — so fall back to the
  // legacy separate print line instead. This is what makes shipping the ladder
  // data and the JS at different moments safe (and covers a variant whose write
  // failed): worst case is the old two-line behaviour, never a silent underprice.
  function ladderCovers(v, raw) {
    var l = (v && v.bundles) || [];
    if (!l.length) return false;
    var base = v ? Number(v.price) / 100 : 0;
    for (var i = 0; i < l.length; i++) if (upMajor(l[i].price, v) + base >= raw - 1e-6) return true;   // raw: presentment
    return false;
  }
  // Absolute price a FIXED size should charge: variant base + the premium uplift
  // (read from the `stripe` bundle — the metafield is authoritative, NOT
  // base×STRIPE_FACTOR) + the photo when it's on.
  function fixedRawTotal() {
    var v = state.variant, base = v ? Number(v.price) / 100 : 0;
    var sb = fixedStripeBundle();
    // PRESENTMENT: host + converted uplift + the base-currency photo converted.
    var raw = base + (sb ? upMajor(sb.price) : 0);
    if (photoPriceActive()) raw += printPriceValue() * bundleRate();
    return raw;
  }
  function photoAbsorbed() {
    if (!printAvailable()) return false;
    if (isCustomActive()) return true;            // custom ladder spans mount+photo by construction
    return photoPriceActive() && ladderCovers(state.variant, fixedRawTotal());
  }
  // Price-side "photo is on": deliberately does NOT require the upload, so the
  // headline shows the true total the moment the toggle flips. The ATC guard
  // still refuses to add without a file, so display and cart can't disagree.
  function photoPriceActive() {
    return !!(elAddPhoto && elAddPhoto.checked) && printAvailable() &&
           !!printOpeningMm() && printPriceValue() != null && !printRollTooLarge();
  }
  // The opening drives the photo price, and on a custom size that price lives
  // inside the mount's bucket — so an opening change must re-price the line.
  // Deliberately NOT called from updateOpeningChip(): recomputeCustom() calls
  // that, so doing it there would recurse.
  function repriceIfPhotoAbsorbed() {
    if (photoAbsorbed() && photoPriceActive()) refreshPrice();
  }

  // Shows the print uplift beside the Add-a-photo checkbox. Visible as soon as
  // an opening is chosen so the buyer sees the price before uploading.
  function updatePrintPrice() {
    if (!elPrintPrice) return;
    if (printRollError()) { elPrintPrice.textContent = 'Too large to print'; return; }
    var price = printAvailable() ? printPriceValue() : null;
    var r = photoAbsorbed() ? bundleRate(state.variant) : printRate();
    elPrintPrice.textContent = price != null ? ('+ ' + formatMoney(Math.round(price * r * 100))) : '';
  }

  function dataURLToBlob(dataUrl) {
    var parts = dataUrl.split(','), mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
    var bin = atob(parts[1]), n = bin.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bin.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }
  // The id that identifies ONE design. Every mount add renders and uploads a
  // board image, so this is always the per-add id once addToCart has run.
  function designKey() { return state.designId || state.sessionId; }

  // What the customer sees of their order at checkout, in the order email and
  // on the order status page. Bundle Pro's expand drops every plain property on
  // a bundled line and keeps only the hidden `_addons_custom` blob; since app
  // v69 it re-attaches the keys listed in `_addon_bundle_pro_display` as
  // VISIBLE properties. Default-deny: only these keys, in this order, under
  // these labels. Print file, Photo original/crop, Personalisation image, Frame
  // Only, Mount external, Opening size and the session id stay hidden; the
  // full record still goes to `_addons_custom` untouched.
  // Same list in pfc-moulding.js, pfc-mount.js and pfc-print-app.js — keep in step.
  var BUNDLE_DISPLAY = [
    ['Image Preview', 'Your design'], ['Board preview', 'Board preview'],
    ['Map', 'Map'], ['Size', 'Size'], ['Orientation', 'Orientation'], ['Print size', 'Print size'], ['Finished size', 'Finished size'],
    ['Frame size', 'Frame size'], ['Frame', 'Frame'], ['Moulding', 'Moulding'], ['Finish', 'Finish'],
    ['Framing style', 'Framing style'], ['Float border', 'Float border'], ['Paper edge', 'Paper edge'], ['Frame opening', 'Frame opening'], ['Mount', 'Mount'], ['Mount colour', 'Mount colour'],
    ['Mount border', 'Mount border'], ['Mount opening', 'Mount opening'], ['Board colour', 'Board colour'],
    ['Border', 'Border'], ['Style', 'Style'], ['Pattern', 'Pattern'], ['Pattern colour', 'Pattern colour'],
    ['Glazing', 'Glazing'], ['Paper', 'Paper'], ['Fit', 'Fit'], ['Print', 'Print'], ['Supplied as', 'Supplied as'],
    ['Personalisation', 'Personalisation'], ['Printed text', 'Printed text'], ['Font', 'Font'], ['Alignment', 'Alignment']
  ];
  /** `_addon_bundle_pro_display` for one line (JSON string), or null if nothing qualifies. */
  function bundleDisplayFor(src, logoUrl) {
    var out = {}, n = 0;
    BUNDLE_DISPLAY.forEach(function (pair) {
      var v = src[pair[0]];
      if (typeof v !== 'string' && typeof v !== 'number') return;
      v = String(v).trim();
      if (v) { out[pair[1]] = v; n++; }
    });
    // The customer's ORIGINAL logo file (uploaded with the personalisation).
    if (logoUrl) { out['Your logo'] = logoUrl; n++; }
    return n ? JSON.stringify(out) : null;
  }
  /** The uploaded original logo, when the printed personalisation has one. */
  function persLogoUrl(spec) { return spec && spec.logo && spec.logo.url ? spec.logo.url : null; }

  // What Bundle Pro charges for an add-on, in presentment MAJOR units. Mirrors
  // the cart transform's addonCharge (app v69+): with no conversion at all
  // (rate exactly 1: the shop's own currency, no price-list adjustment) the
  // add-on is charged to the penny; converted markets stay whole units. Quoting
  // Math.round(price * rate) everywhere showed a £8.25 mount as £8 while the
  // cart charged £8.25. Same function in pfc-moulding.js, pfc-mount.js and
  // pfc-print-app.js, and in the studio's convertBundle — keep in step.
  function addonChargeMajor(price, rate) {
    var p = Number(price) || 0, r = Number(rate);
    if (r === 1) return Math.round(p * 100) / 100;
    return Math.round(p * r);
  }

  function uploadKey(suffix) {
    var d = new Date(), ym = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    return (cfg.uploadPrefix || 'mount-print') + '/' + ym + '/' + designKey() + '/' + state.variant.id + '-' + suffix;
  }
  function publicS3Url(key) { return 'https://' + cfg.uploadBucket + '.s3.eu-west-2.amazonaws.com/' + key; }
  function uploadOne(dataUrl, key) {
    var form = new URLSearchParams();
    form.append('bucket', cfg.uploadBucket); form.append('key', key); form.append('type', 'put');
    return fetch(cfg.gcfUploadUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: form })
      .then(function (r) { return r.text(); })
      .then(function (signedUrl) {
        return fetch(signedUrl, { method: 'PUT', headers: { 'Content-Type': 'image/jpeg' }, body: dataURLToBlob(dataUrl) });
      });
  }
  // Only the small preview goes up here — the original is already uploaded
  // (photoSrc) and the print is cut from it using `photo.crop`.
  function uploadPrintImage(photo) {
    var prevKey = uploadKey('preview.jpg');
    return uploadOne(state.previewDataUrl, prevKey)
      .then(function (r) { if (r && r.ok === false) throw new Error('preview upload ' + r.status); })
      .then(function () { return { previewUrl: publicS3Url(prevKey), photo: photo }; });
  }

  // Add-to-cart is unusable while the original is still uploading: an order must
  // never reference an original that is not in S3. Failed → the button retries.
  function syncAtcGate() {
    if (!elAtc) return;
    var ph = photoSrc ? photoSrc.state() : { status: 'idle' };
    if (ph.status === 'uploading') {
      elAtc.disabled = true;
      elAtc.textContent = 'Uploading photo… ' + Math.floor(ph.progress * 100) + '%';
      return;
    }
    if (ph.status === 'error') {
      elAtc.disabled = adding;
      elAtc.textContent = 'Photo upload failed — tap to retry';
      return;
    }
    elAtc.disabled = adding;
    if (!adding) syncSheet();   // restores the "Add to cart · £x" label
  }

  // The true-to-order board render (see renderLineImage). Uploaded on EVERY add
  // to cart, not just premium ones — the mounter needs to see the board that was
  // ordered whatever tier it is.
  function uploadBoardImage() {
    var dataUrl = renderLineImage();
    if (!dataUrl) return Promise.resolve(null);
    var key = uploadKey('board.jpg');
    return uploadOne(dataUrl, key).then(function () { return { url: publicS3Url(key) }; });
  }

  function uploadPattern() {
    var key = uploadKey('pattern.jpg');
    return uploadOne(state.patternDataUrl, key).then(function () { return { url: publicS3Url(key) }; });
  }

  function loadPatternFile(file) {
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.patternDataUrl = e.target.result;
      var img = new Image();
      img.onload = function () {
        state.patternImg = img;
        if (elPatternDrop) elPatternDrop.dataset.hasImage = 'true';
        if (elPatternTitle) elPatternTitle.textContent = 'Pattern added — click to replace';
        renderPreview();
      };
      img.src = state.patternDataUrl;
    };
    reader.readAsDataURL(file);
  }

  /* ---------- ATC ---------- */
  function addToCart() {
    if (adding) return;
    if (photoSrc && photoSrc.failed()) { flashStatus('Retrying your photo upload…'); photoSrc.retry(); return; }
    if (photoSrc && photoSrc.busy()) return;   // button is disabled; belt and braces
    if (isCustomActive() && !state.customBucket) {
      flashStatus('Enter a valid custom frame size first.');
      return;
    }
    var oErr = openingError();
    if (oErr) { flashStatus(oErr); return; }
    if (isPersActive()) { var pErr = pf().addError(); if (pErr) { flashStatus(pErr); return; } }
    var rErr = printRollError();
    if (rErr) { flashStatus(rErr); return; }
    if (state.useCustomOpening && (!state.openingW || !state.openingH)) {
      flashStatus('Enter your print (opening) size first.');
      return;
    }
    if (isPattern() && !state.patternImg) { flashStatus('Upload your pattern first.'); return; }
    // Add-a-photo ticked but nothing uploaded: isPrintMode() is false, so the
    // print line is never pushed and the buyer silently gets a mount-only order
    // at the mount-only price. Block it like the pattern upload above.
    if (elAddPhoto && elAddPhoto.checked && printAvailable() && !state.userImg) {
      flashStatus('Upload your photo first, or turn off "Add my photo".');
      return;
    }
    // Ratio moved and the original was gone, so the files on hand are cut to the
    // wrong shape. Never let that reach the cart — it prints the wrong picture.
    if (state.userImg && (state.cropStale || (cropAspectDrifted() && !recropToAspect()))) {
      if (state.originalUrl) { flashStatus('Please re-crop your photo for this size.'); reopenCropper(); }
      else { flashStatus('Please add your photo again for this size.'); elFileInput && elFileInput.click(); }
      return;
    }
    // Mint this add's design id BEFORE any upload key is built, so two designs
    // added from one page load get distinct S3 paths and distinct cart lines.
    // Nothing uploaded but the board render → its pixels are a pure function of
    // the line properties, so an identical add overwrites itself harmlessly;
    // keep the session id there and let those lines merge as before.
    // A printed photo: the order needs the original and the exact box it was cut
    // to, measured against the displayed (EXIF-applied) image, and that crop must
    // belong to THIS upload.
    var photo = null;
    if (isPrintMode()) {
      if (!photoSrc || !photoSrc.ready() || !state.srcImg || !state.srcImg.naturalWidth
          || state.cropFor !== photoSrc.state().url) {
        flashStatus('Please add your photo again.'); elFileInput && elFileInput.click(); return;
      }
      photo = {
        url: photoSrc.state().url,
        crop: window.PFCPhotoSource.cropSpec(state.cropData, state.srcImg.naturalWidth, state.srcImg.naturalHeight),
      };
    }
    state.designId = (isPrintMode() || isPattern() || isPersActive()) ? cryptoRandom() : null;

    adding = true;
    elAtc.disabled = true;
    var jobs = {}, ps = [];
    ps.push(uploadBoardImage().then(function (u) { jobs.board = u; })
      .catch(function (e) { console.warn('PFC mount board render upload failed (non-fatal)', e); }));
    if (photo) ps.push(uploadPrintImage(photo).then(function (u) { jobs.print = u; }));
    if (isPattern() && state.patternDataUrl) ps.push(uploadPattern().then(function (u) { jobs.pattern = u; }));
    if (isPersActive()) { var persPng = renderPersExport(); if (persPng) ps.push(uploadPersImage(persPng).then(function (u) { jobs.pers = u; })); }
    var prep;
    if (ps.length) { flashStatus('Uploading…'); prep = Promise.all(ps).then(function () { return jobs; }); }
    else { flashStatus('Adding to cart…'); prep = Promise.resolve(null); }
    prep.then(function (up) { return postCart(up); })
      .then(function (res) { if (!res.ok) throw new Error(res.statusText); return res.json(); })
      .then(function (data) { injectCartSections(data); flashStatus('Added to cart.'); openCartDrawer(); })
      .catch(function (err) { console.error('PFC mount ATC error', err); flashStatus('Could not add to cart — please try again.'); })
      .finally(function () { adding = false; syncAtcGate(); });
  }

  function postCart(uploaded) {
    var v = state.variant;
    var custom = !!v.isCustom;
    // The photo's price is already inside the matched ladder bucket, so it must
    // NOT also be added as its own line (that would charge it twice). True for a
    // custom size, and for a fixed size whose ladder reaches the combined total.
    // Anything else falls back to the legacy separate print line.
    var absorbFixed = !custom && photoAbsorbed() && !!state.fixedBucket;
    var printAbsorbedLine = printAvailable() && (custom || absorbFixed);
    var d = boardDimsMm(v);
    var apd = apertureDims();
    var sizeLabel = custom
      ? 'Custom ' + Math.round(d.w) + '×' + Math.round(d.h) + 'mm'
      : (v.options && v.options.Size ? v.options.Size : v.title);
    var props = {
      'Size': sizeLabel,
      // Frameless product → this is the mount board outer, not a frame. Named
      // 'Mount external' to match the moulding/studio order vocabulary.
      // See docs/ORDER-MOUNT-DIMS-SPEC.md.
      'Mount external': (d.w && d.h) ? fmtProdDim(d.w, d.h, custom ? null : v.title) : sizeLabel,
      'Orientation': orientationOf(v),
      'Board colour': usesPatternColour()
                        ? ('White + ' + stripePresetLabel(state.stripeColour) + ' ' + (state.colour.label || '').toLowerCase())
                      : isPattern() ? 'Custom uploaded pattern' : state.colour.label,
      'id': designKey(),
    };
    if (usesPatternColour()) {
      props['Style'] = state.colour.label || 'Patterned';
      props['Pattern colour'] = stripePresetLabel(state.stripeColour) + ' (' + state.stripeColour + ')';
    } else if (isPattern()) {
      props['Style'] = 'Custom uploaded pattern';
    }
    if (uploaded && uploaded.pattern) {
      props['Pattern image'] = uploaded.pattern.url;
      props['_addon_bundle_pro_image'] = uploaded.pattern.url; // Bundle Pro line-image input
      props['_print_file'] = uploaded.pattern.url;             // full-res for fulfillment (hidden)
    }
    // Preset pattern (stripes/checkers/etc., not an uploaded image) → Shopify-hosted
    // swatch as the Bundle Pro (parent) line image, so checkout reads as a patterned
    // mat instead of the generic mount photo. It MUST be a Shopify Files URL: an S3
    // one is rejected by the cart-transform (see the CDN guard below).
    //
    // Keyed PATTERN + COLOUR (`fine-sage`). The original map was keyed on pattern
    // alone and every tile was baked Navy, so a sage order showed a navy mat in
    // the Shopify admin — the mounter cut to it and shipped the wrong colour
    // (US order PFC-1332049). A style-only key is therefore only trustworthy for
    // the colour it was baked in; for anything else we send NO image and let the
    // line fall back to the product photo. A neutral image beats a wrong one —
    // the true render travels on `Board preview` / `_pfc_cart_image` below.
    // Regenerate the tiles with scripts/pfc-mount-swatches.mjs.
    if (!props['_addon_bundle_pro_image'] && usesPatternColour() && cfg.patternSwatches) {
      var c = state.colour || {};
      var sw = cfg.patternSwatches;
      var cslug = stripePresetLabel(state.stripeColour).toLowerCase().replace(/[^a-z0-9]+/g, '-');
      var swatch = sw[c.key + '-' + cslug] || sw[c.type + '-' + cslug];
      if (!swatch && cslug === 'navy') swatch = sw[c.key] || sw[c.type] || sw['default'];
      if (swatch) props['_addon_bundle_pro_image'] = swatch;
    }
    // The swatch is a stock tile at a stock aspect; the board render is the
    // actual order — right colour, right proportions, right opening. Carry it as
    // a visible property (so it survives the expand inside `_addons_custom` and
    // the print-file admin app can show it) plus the cart-drawer thumbnail.
    if (uploaded && uploaded.board) {
      props['Board preview'] = uploaded.board.url;
      props['_pfc_cart_image'] = uploaded.board.url;
    }
    if (apd) {
      // Frameless mount: the customer prints to the opening, so Print size == opening.
      // Exact mm (cut dim), falling back to the coarse label only when mm is absent.
      var opStr = (apd.w && apd.h) ? fmtProdDim(apd.w, apd.h, apd.label) : apd.label;
      props['Print size'] = opStr;
      props['Mount opening'] = opStr;
      if (d.w && d.h) {
        var bw = (d.w - apd.w) / 2, bh = (d.h - apd.h) / 2;
        // Inch-aware, matching fmtProdDim: 2dp inch / whole mm. Collapse to one
        // value when the two axes match (even border).
        var even = Math.round(bw) === Math.round(bh);
        // Inch board + inch opening: border from the exact inches (11x14 board,
        // 8x10 opening = 1.5 x 2", not the 1.50 x 2.01" whole mm gives).
        var dIn = exactInchPair(d.w, d.h, custom ? null : v.title), aIn = exactInchPair(apd.w, apd.h, apd.label);
        var bwIn = (dIn && aIn) ? (dIn.w - aIn.w) / 2 : bw / 25.4, bhIn = (dIn && aIn) ? (dIn.h - aIn.h) / 2 : bh / 25.4;
        if (dIn && aIn) even = Math.abs(bwIn - bhIn) < 0.005;
        // Border in the board's own unit (an A-size or cm board -> mm).
        var borderIn = custom ? dispIn() : !!dIn;
        props['Border'] = borderIn
          ? (even ? fmtInch(bwIn) + '"' : fmtInch(bwIn) + '×' + fmtInch(bhIn) + '"')
          : (even ? Math.round(bw) + 'mm' : Math.round(bw) + '×' + Math.round(bh) + 'mm');
      }
    }
    props['Supplied as'] = (NOUN === 'mat' ? 'Mat' : 'Mount') + ' only — no frame, no print';

    // Premium reprice (Decision A): a patterned finish AND/OR printed text/logo
    // both price at the premium tier via the SAME self-referential 'stripe'
    // reprice. The displayed line title names the actual finish (pattern and/or
    // printed text), not a generic "Striped mount".
    // (isStripes preserved from the original pattern path; isPersActive adds text.)
    if (!custom && (isStripes() || isPersActive())) {
      var sbp = fixedStripeBundle();
      if (sbp) {
        props['_upsell_bundles_pro_selected'] = sbp.id;
        props['_addon_bundle_pro_title'] = premiumLineTitle();
      }
    }
    // Fixed size + photo: ONE combined bucket (mount + premium uplift + photo)
    // replaces the `stripe` id set above — its price already includes the premium
    // tier, so keeping `stripe` would drop the photo from the charge.
    if (!custom && absorbFixed && state.fixedBucket) {
      props['_upsell_bundles_pro_selected'] = state.fixedBucket.id;
      props['_addon_bundle_pro_title'] = premiumActive() ? premiumLineTitle()
        : (NOUN === 'mat' ? 'Mat + printed photo' : 'Mount + printed photo');
    }
    // Custom size: charge via the matched Bundle Pro ladder bucket (the bucket was
    // already raised by STRIPE_FACTOR in recomputeCustom when premium is active).
    if (custom && state.customBucket) {
      props['_upsell_bundles_pro_selected'] = state.customBucket.id;
      props['_addon_bundle_pro_title'] = premiumActive() ? premiumLineTitle()
        : ((function () { var cv = customVariant(); var b = ((cv && cv.bundles) || []).find(function (x) { return x.id === state.customBucket.id; }); return b && b.name ? b.name : 'Custom size'; })());
    }

    var items = [{ id: v.id, quantity: 1, properties: props }];

    // Print-for-me, CUSTOM SIZE: absorbed — the photo rides on the mount line and
    // its price is already inside the matched bucket above. One physical item
    // (mat + mounted photo) = one cart line. The photo travels as the untouched
    // original + crop box (`_photo_src` / `_photo_crop`), which the carry loop
    // below re-emits inside `_addons_custom`; the print-file admin app cuts the
    // print from them and treats it as the line's primary asset. A pattern or
    // caption keeps its own `_print_file` alongside.
    if (uploaded && uploaded.print && printAbsorbedLine) {
      var oa = printOpeningMm();
      props['Supplied as'] = (NOUN === 'mat' ? 'Mat' : 'Mount') + ' + printed photo';
      props['Print'] = 'Yes — we print & mount your photo';
      props['Print size'] = oa ? (Math.round(oa.w) + '×' + Math.round(oa.h) + 'mm' + (apd ? ' (' + apd.label + ')' : '')) : props['Print size'];
      props['Image Preview'] = uploaded.print.previewUrl;
      props['_photo_src'] = uploaded.print.photo.url;     // untouched original (hidden)
      props['_photo_crop'] = uploaded.print.photo.crop;   // box to cut the print from it
      // Board render already shows the photo inside the opening, so it's the
      // better thumbnail; fall back to the bare photo if that render failed.
      if (!props['_pfc_cart_image']) props['_pfc_cart_image'] = uploaded.print.previewUrl;
    }

    // Print-for-me, FIXED SIZE: no ladder to absorb into, so keep the legacy
    // second (custom-print) line, area-priced by its own `pc-*` ladder. Fixed
    // sizes are the immediate follow-up — see docs/MOUNT-PHOTO-ABSORB-SCOPE.md.
    if (uploaded && uploaded.print && printAvailable() && !printAbsorbedLine) {
      var o = printOpeningMm();
      props['Supplied as'] = (NOUN === 'mat' ? 'Mat' : 'Mount') + ' + printed photo';
      props['Print'] = 'Yes — we print & mount your photo';
      var pPrice = printPriceValue();
      var pBucket = matchPrintBucket(pPrice);
      var printProps = {
        'Printed for': sizeLabel + (NOUN === 'mat' ? ' mat' : ' mount'),
        'Print size': o ? (Math.round(o.w) + '×' + Math.round(o.h) + 'mm' + (apd ? ' (' + apd.label + ')' : '')) : '',
        'Image Preview': uploaded.print.previewUrl,
        '_addon_bundle_pro_image': uploaded.print.previewUrl, // Bundle Pro line-image input (S3 → stripped by the CDN guard below)
        '_pfc_cart_image': uploaded.print.previewUrl,      // cart/drawer thumbnail (plain prop, never a function input)
        '_photo_src': uploaded.print.photo.url,            // untouched original (hidden)
        '_photo_crop': uploaded.print.photo.crop,          // box to cut the print from it
        'id': designKey(),
      };
      if (pBucket) {
        printProps['_upsell_bundles_pro_selected'] = pBucket.id;
        if (pBucket.name) printProps['_addon_bundle_pro_title'] = pBucket.name;
      }
      items.push({ id: printConfig().customVariantId, quantity: 1, properties: printProps });
    }

    // Printed text/logo rides ON the mat line itself (Decision A) — NOT a separate
    // line. The premium reprice above already covers it (premium = pattern AND/OR
    // text). Add descriptive properties + the rendered artwork; the props are
    // mirrored into `_addon_bundle_pro_personalisations` below (the only blob that
    // survives Bundle Pro expand).
    if (uploaded && uploaded.pers && isPersActive()) {
      var persText = [state.pers.heading, state.pers.line2].filter(function (s) { return s && s.trim(); }).join(' / ');
      var alignCap = state.pers.align.charAt(0).toUpperCase() + state.pers.align.slice(1);
      props['Personalisation'] = persHasLogo() ? ('Text + logo (' + state.pers.logoPos + ')') : 'Text';
      props['Printed text'] = persText || '(logo only)';
      props['Alignment'] = alignCap;
      props['Font'] = state.pers.font;
      props['Personalisation image'] = uploaded.pers.url;
      props['_print_file'] = uploaded.pers.url; // full-res for fulfillment (carried into _addons_custom)
      if (!props['_addon_bundle_pro_image']) props['_addon_bundle_pro_image'] = uploaded.pers.url; // cart line-image when no pattern image
    }

    // Bundle Pro's cart-transform EXPAND replaces a bundled source line with
    // its components; only `_addon_bundle_pro_personalisations` survives the
    // split. Per item, mirror its human-readable props into that JSON whenever
    // it carries a bundle, else Board colour/Style/Border/Print specs never
    // reach the Shopify order. No bundle => no expand => plain props survive.
    items.forEach(function (it) {
      var ip = it.properties || {};
      if (!ip['_upsell_bundles_pro_selected']) return;
      // Bundle Pro's cart-transform EXPAND sets `image.url` from
      // `_addon_bundle_pro_image`; Shopify accepts ONLY a full https Shopify-CDN
      // URL there. An S3 upload (or a protocol-relative `//cdn…`) throws
      // InvalidOutputError, which rejects the function's ENTIRE operations list —
      // so every bundle line in the cart silently drops to its bare variant base,
      // not just this one. Live-proven: order PFC-1332049 (S3 print line dragged
      // the CDN-swatch mat line down with it). Preset-pattern swatches are Files
      // URLs and survive; keep the real preview on `_pfc_cart_image` instead,
      // which is a plain property the function never reads.
      var bimg = ip['_addon_bundle_pro_image'];
      if (bimg) {
        if (bimg.indexOf('//') === 0) bimg = ip['_addon_bundle_pro_image'] = 'https:' + bimg;
        if (bimg.indexOf('https://cdn.shopify.com/') !== 0) {
          if (!ip['_pfc_cart_image']) ip['_pfc_cart_image'] = bimg;
          delete ip['_addon_bundle_pro_image'];
        }
      }
      var carry = {};
      Object.keys(ip).forEach(function (k) {
        if (k.charAt(0) !== '_') carry[k] = ip[k];
      });
      // Full-res file: only the personalisations JSON survives the expand (lands
      // as the underscore `_addons_custom` blob => admin-only), so include the
      // full-res URL there. Sourced from the real upload, NOT from
      // `_addon_bundle_pro_image` (that's Bundle Pro's line-image input).
      if (ip['_print_file']) carry['Print file'] = ip['_print_file'];
      // Same for the photo: the copy above skips underscore keys.
      if (ip['_photo_src']) carry['Photo original'] = ip['_photo_src'];
      if (ip['_photo_crop']) carry['Photo crop'] = ip['_photo_crop'];
      if (ip === props && ip['Printed text'] && lastPersRenderSpec) carry['_pers_render'] = lastPersRenderSpec;
      ip['_addon_bundle_pro_personalisations'] = JSON.stringify(carry);
      var display = bundleDisplayFor(carry, ip === props && ip['Printed text'] ? persLogoUrl(lastPersRenderSpec) : null);
      if (display) ip['_addon_bundle_pro_display'] = display;
    });

    var body = {
      items: items,
      sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text,header-drawer'
    };
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function injectCartSections(data) {
    if (!data.sections) return;
    try {
      if (data.sections['cart-drawer'] && document.querySelector('cart-drawer')) {
        var v1 = document.createElement('div');
        v1.innerHTML = data.sections['cart-drawer'];
        var drawer = document.querySelector('cart-drawer');
        var fresh = v1.querySelector('cart-drawer');
        if (drawer && fresh) drawer.outerHTML = fresh.outerHTML;
        v1.remove();
      }
    } catch (_) {}
    try {
      if (data.sections['cart-icon-bubble'] && document.getElementById('cart-icon-bubble')) {
        var v2 = document.createElement('div');
        v2.innerHTML = data.sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        var freshB = v2.querySelector('#cart-icon-bubble') || v2.firstElementChild;
        if (bubble && freshB) bubble.innerHTML = freshB.innerHTML;
        v2.remove();
      }
    } catch (_) {}
  }

  function openCartDrawer() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) { try { bubble.dispatchEvent(new Event('click')); } catch (_) {} }
  }

  /* ---------- Helpers ---------- */
  function orientationOf(v) {
    // The Custom Size variant title carries no dims, so parseDim returns null for
    // it — every custom order therefore recorded "Square" (PFC-UK-1338309: a
    // 500×700 board labelled Square). Read the entered dims instead, same source
    // boardDimsMm uses.
    var d = (v && v.isCustom)
      ? { w: state.customW || 0, h: state.customH || 0 }
      : parseDim(v);
    if (!d || !d.w || !d.h) return 'Square';
    if (d.w === d.h) return 'Square';
    return state.orientation === 'landscape' ? 'Landscape' : 'Portrait';
  }

  function flashStatus(text) { if (elAtcStatus) elAtcStatus.textContent = text || ''; }
  // Photo-upload messages: a toast the customer will actually see, plus the
  // status line for errors so the reason is still there after the toast goes.
  function uploadNotice(text, kind) {
    if (kind === 'error') flashStatus(text); else if (kind === 'busy') flashStatus('');
    if (window.PFCPhotoSource && window.PFCPhotoSource.notice) window.PFCPhotoSource.notice(text, kind);
  }

  function cryptoRandom() {
    try {
      var arr = new Uint8Array(16); crypto.getRandomValues(arr);
      return Array.from(arr).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    } catch (_) {
      return String(Date.now()) + Math.random().toString(16).slice(2);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Wiring ---------- */
  if (elSizeTrigger) {
    elSizeTrigger.addEventListener('click', function () {
      setSizeOpen(elSizeList.hidden);
    });
    document.addEventListener('click', function (e) {
      if (elSizeSelect && !elSizeSelect.contains(e.target)) setSizeOpen(false);
    });
  }

  elSceneBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.scene = b.dataset.sceneBtn;
      elSceneBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      renderPreview();
    });
  });

  elOrientBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.orientation = b.dataset.orientationBtn;
      elOrientBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      updateOpeningChip();
      applyPreviewAspect();
      renderPreview();
      renderSizeList();
      if (elSizeValue && state.variant && !state.variant.isCustom) elSizeValue.textContent = orientedTitle(state.variant.title);
    });
  });

  function setSizeUnit(unit) {
    if (unit !== 'cm' && unit !== 'in') return;
    state.sizeUnit = unit;
    elSizeUnitBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.sizeUnit === unit ? 'true' : 'false');
    });
    renderSizeList();
    // If the selected size isn't in this unit (and isn't a custom size), switch
    // to the first size of the chosen unit so the trigger/preview stay in sync.
    if (!isCustomActive() && variantUnit(state.variant) !== unit) {
      var first = cfg.variants.find(function (v) { return !v.isCustom && variantUnit(v) === unit; });
      if (first) selectVariant(first);
    }
    updateOpeningChip();   // re-render badges in the new display unit
  }
  elSizeUnitBtns.forEach(function (b) {
    b.addEventListener('click', function () { setSizeUnit(b.dataset.sizeUnit); });
  });

  if (elAddPhoto) {
    elAddPhoto.addEventListener('change', function () {
      setUploadOpen(elAddPhoto.checked);
      if (!elAddPhoto.checked) {
        state.userImg = null;
        state.cropFor = null;
        if (photoSrc) photoSrc.clear();   // stop uploading a photo nobody wants
        if (elPreview) elPreview.dataset.hasImage = 'false';
        renderPreview();
      }
      updatePrintPrice();
      // Custom size absorbs the photo into the headline price + ladder bucket, so
      // toggling it must re-price the line (not just the "+ £x" chip).
      refreshPrice();
    });
  }
  if (elPatternDrop) elPatternDrop.addEventListener('click', function (e) {
    if (e.target.closest('input')) return;
    elPatternInput && elPatternInput.click();
  });
  if (elPatternInput) elPatternInput.addEventListener('change', function () {
    var f = elPatternInput.files && elPatternInput.files[0];
    if (f) loadPatternFile(f);
    elPatternInput.value = '';
  });
  if (elUpload) {
    elUpload.addEventListener('click', function (e) {
      if (e.target.closest('[data-upload-actions]')) return;
      if (elUpload.dataset.hasImage === 'true') { reopenCropper(); return; }
      elFileInput && elFileInput.click();
    });
  }
  if (elFileInput) {
    elFileInput.addEventListener('change', function () {
      var f = elFileInput.files && elFileInput.files[0];
      if (f) openCropper(f);
      elFileInput.value = '';
    });
  }
  if (elRecrop) elRecrop.addEventListener('click', function (e) { e.stopPropagation(); reopenCropper(); });
  if (elReplace) elReplace.addEventListener('click', function (e) { e.stopPropagation(); elFileInput && elFileInput.click(); });
  if (elCropCancel) elCropCancel.addEventListener('click', cancelCrop);
  if (elCropConfirm) elCropConfirm.addEventListener('click', confirmCrop);
  if (elAtc) elAtc.addEventListener('click', addToCart);

  // Personalisation wiring.
  if (elPersToggle) elPersToggle.addEventListener('change', function () {
    state.pers.on = elPersToggle.checked;
    if (elPersPanel) elPersPanel.hidden = !elPersToggle.checked;
    updatePersWarning();
    refreshPrice();   // text drives the premium tier (Decision A) — update headline
    syncPersSizeSteps(0, 0, 1);  // reset step UI; the render re-syncs if text present
    renderPreview();
  });
  if (elPersFontTrigger) {
    elPersFontTrigger.addEventListener('click', function () { setPersFontOpen(elPersFontList.hidden); });
    document.addEventListener('click', function (e) {
      if (elPersFontSelect && !elPersFontSelect.contains(e.target)) setPersFontOpen(false);
    });
  }
  elPersAlignBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.pers.align = b.dataset.persAlign;
      elPersAlignBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      renderPreview();
    });
  });
  elPersSizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.pers.size = b.dataset.persSize;
      elPersSizeBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      renderPreview();
    });
  });
  if (PF && elPersPanel) {
    persFit = PF.controller({
      state: function () { return state.pers; },
      zoneMm: persZoneMm,
      familyCss: fontFamilyCss,
      sizeBtns: elPersSizeBtns, sizeNote: elPersSizeNote,
      heading: elPersHeading, line2: elPersLine2,
      rerender: function () { renderPreview(); }
    });
  }
  if (elPersHeading) elPersHeading.addEventListener('input', function () { state.pers.heading = elPersHeading.value; refreshPrice(); renderPreview(); });
  if (elPersLine2) elPersLine2.addEventListener('input', function () { state.pers.line2 = elPersLine2.value; refreshPrice(); renderPreview(); });
  if (elPersLogoToggle) elPersLogoToggle.addEventListener('change', function () {
    state.pers.logoOn = elPersLogoToggle.checked;
    updateLogoFields();
    refreshPrice(); // a logo alone can satisfy content → premium
    renderPreview();
  });
  elPersLogoPosBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.pers.logoPos = b.dataset.persLogoPos;
      elPersLogoPosBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      renderPreview();
    });
  });
  if (elPersLogoDrop) {
    elPersLogoDrop.addEventListener('click', function (e) {
      if (e.target.closest('input')) return;
      elPersLogoInput && elPersLogoInput.click();
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      elPersLogoDrop.addEventListener(ev, function (e) { e.preventDefault(); elPersLogoDrop.dataset.dragover = 'true'; });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
      elPersLogoDrop.addEventListener(ev, function () { elPersLogoDrop.removeAttribute('data-dragover'); });
    });
    elPersLogoDrop.addEventListener('drop', function (e) {
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f && /^image\/(png|jpe?g)$/.test(f.type)) loadPersLogoFile(f);
    });
  }
  if (elPersLogoInput) elPersLogoInput.addEventListener('change', function () {
    var f = elPersLogoInput.files && elPersLogoInput.files[0];
    if (f) loadPersLogoFile(f);
    elPersLogoInput.value = '';
  });

  if (elCustomW) elCustomW.addEventListener('input', recomputeCustom);
  if (elCustomH) elCustomH.addEventListener('input', recomputeCustom);
  elCustomUnitBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var newUnit = b.dataset.customUnit;
      if (newUnit === state.customUnit) return;
      [elCustomW, elCustomH].forEach(function (inp) {
        if (!inp || !inp.value) return;
        var n = parseFloat(inp.value); if (!n) return;
        inp.value = newUnit === 'in' ? (n / 2.54).toFixed(1) : (n * 2.54).toFixed(1);
      });
      state.customUnit = newUnit;
      elCustomUnitBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      recomputeCustom();
    });
  });

  // Advanced: custom frame-size toggle.
  if (elCustomFrameToggle) {
    elCustomFrameToggle.addEventListener('change', function () {
      var cv = customVariant();
      if (elCustomFrameToggle.checked && cv) {
        if (!state.variant.isCustom) state.prevStandardVariant = state.variant;
        if (elCustom) elCustom.hidden = false;
        selectVariant(cv);
      } else {
        if (elCustom) elCustom.hidden = true;
        var back = state.prevStandardVariant || cfg.variants.find(function (v) { return !v.isCustom; });
        if (back) selectVariant(back);
      }
    });
  }

  // Advanced: custom opening toggle.
  if (elCustomOpeningToggle) {
    elCustomOpeningToggle.addEventListener('change', function () {
      state.useCustomOpening = elCustomOpeningToggle.checked;
      if (elOpeningCustom) elOpeningCustom.hidden = !state.useCustomOpening;
      // Preset opening picker only applies to a standard frame without custom opening.
      if (elApertures) elApertures.hidden = state.useCustomOpening || isCustomActive() || !aperturesFor(state.variant.title);
      if (state.useCustomOpening) recomputeOpening();   // reprices for the absorbed photo itself
      else { updateOpeningChip(); renderPreview(); repriceIfPhotoAbsorbed(); }
    });
  }
  if (elOpeningW) elOpeningW.addEventListener('input', recomputeOpening);
  if (elOpeningH) elOpeningH.addEventListener('input', recomputeOpening);
  elOpeningUnitBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var newUnit = b.dataset.openingUnit;
      if (newUnit === state.openingUnit) return;
      [elOpeningW, elOpeningH].forEach(function (inp) {
        if (!inp || !inp.value) return;
        var n = parseFloat(inp.value); if (!n) return;
        inp.value = newUnit === 'in' ? (n / 2.54).toFixed(1) : (n * 2.54).toFixed(1);
      });
      state.openingUnit = newUnit;
      elOpeningUnitBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      recomputeOpening();
    });
  });

  var resizeRaf = null;
  window.addEventListener('resize', function () {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(renderPreview);
  });

  /* ---------- Query-string presets (colour / size / aperture from landing pages) ---------- */
  function applyQueryPresets() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (_) { return; }
    var qColour = (qs.get('colour') || qs.get('color') || '').toLowerCase();
    var qSize = (qs.get('size') || '').trim();
    var qAp = (qs.get('aperture') || '').toLowerCase();
    var qOrient = (qs.get('orientation') || '').toLowerCase();

    if (qColour) {
      // 'stripes' / 'striped' select the default stripe style; an exact stripe
      // key (e.g. 'stripes-3mm') selects that specific preset.
      if (qColour.indexOf('stripe') === 0) {
        var exact = (cfg.boardColours || []).find(function (x) { return x.type === 'stripes' && x.key.toLowerCase() === qColour; });
        var sc = exact || (cfg.boardColours || []).find(function (x) { return x.type === 'stripes'; });
        if (sc) state.colour = sc;
      } else {
        var c = (cfg.boardColours || []).find(function (x) { return x.key.toLowerCase() === qColour || x.label.toLowerCase() === qColour; });
        if (c) state.colour = c;
      }
    }
    var qStripe = normaliseHex(qs.get('stripe') || qs.get('stripecolour') || qs.get('stripecolor'));
    if (qStripe) state.stripeColour = qStripe;
    if (qOrient === 'landscape' || qOrient === 'portrait') state.orientation = qOrient;
    if (qSize) {
      var norm = qSize.toLowerCase().replace(/\s+/g, '');
      if (norm === 'custom' || norm === 'customsize') {
        var cv = customVariant(); if (cv) state.variant = cv;
      } else {
        var m = cfg.variants.find(function (v) {
          return !v.isCustom && v.title.toLowerCase().replace(/\s+/g, '') === norm;
        });
        if (m) state.variant = m;
      }
    }
    if (qAp) state.aperture = qAp;  // validated against the size's map in renderApertures
  }

  /* ---------- Mobile bottom-sheet (ported from pfc-moulding.js) ---------- */
  (function initSheet() {
    if (!elSheet || !elSheetHandle) return;
    var MOBILE_BP = 920, DRAG_THRESHOLD = 6, FLICK_VELOCITY = 0.6;
    var s = { mode: 'peek', dragging: false, pointerId: null, startY: 0, lastY: 0, lastT: 0, velocity: 0, moved: false, sheetH: 0, peekH: 0 };

    function measure() {
      s.sheetH = elSheet.offsetHeight || (window.innerHeight * 0.88);
      s.peekH = elSheetHandle.offsetHeight || Math.round(window.innerHeight * 0.08);
      document.documentElement.style.setProperty('--peek-h', s.peekH + 'px');
    }
    function setBodyState() {
      document.body.setAttribute('data-sheet-state', s.mode);
      elSheetHandle.setAttribute('aria-expanded', s.mode === 'full' ? 'true' : 'false');
    }
    function setMode(mode) { s.mode = mode === 'full' ? 'full' : 'peek'; elSheet.style.transform = ''; setBodyState(); applyScrolledPast(); }
    function isMobile() { return window.innerWidth <= MOBILE_BP; }
    function activate() {
      if (document.body.getAttribute('data-sheet-active') === 'true') return;
      document.body.setAttribute('data-sheet-active', 'true'); measure(); setBodyState();
    }
    function deactivate() {
      if (s.dragging) return;
      if (document.body.getAttribute('data-sheet-active') !== 'true') return;
      document.body.removeAttribute('data-sheet-active');
      document.body.removeAttribute('data-sheet-state');
      document.body.removeAttribute('data-sheet-dragging');
      document.body.removeAttribute('data-sheet-scrolled-past');
      elSheet.style.transform = '';
    }
    var sentinel = root.querySelector('[data-preview]') || elCanvas || root;
    var previewVisible = true, rafQueued = false;
    function applyScrolledPast() {
      var condense = !previewVisible && s.mode === 'peek';
      if (condense) document.body.setAttribute('data-sheet-scrolled-past', 'true');
      else document.body.removeAttribute('data-sheet-scrolled-past');
      requestAnimationFrame(measure);
    }
    function checkInView() {
      rafQueued = false;
      if (!isMobile()) {
        if (document.body.getAttribute('data-sheet-active') === 'true') deactivate();
        document.body.removeAttribute('data-sheet-scrolled-past');
        return;
      }
      if (document.body.getAttribute('data-sheet-active') !== 'true') activate();
      var r = sentinel.getBoundingClientRect();
      var vh = document.documentElement.clientHeight || window.innerHeight;
      var visible = Math.max(0, Math.min(vh, r.bottom) - Math.max(0, r.top));
      if (previewVisible) { if (visible <= 40) { previewVisible = false; applyScrolledPast(); } }
      else { if (visible >= 120) { previewVisible = true; applyScrolledPast(); } }
    }
    function queueCheck() { if (rafQueued) return; rafQueued = true; requestAnimationFrame(checkInView); }
    requestAnimationFrame(function () { requestAnimationFrame(queueCheck); });
    window.addEventListener('load', queueCheck);
    window.addEventListener('scroll', queueCheck, { passive: true });
    var resizeT = 0;
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(queueCheck, 120); });

    elSheetHandle.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      s.dragging = true; s.moved = false; s.pointerId = e.pointerId;
      s.startY = e.clientY; s.lastY = e.clientY; s.lastT = performance.now(); s.velocity = 0;
      measure();
      try { elSheetHandle.setPointerCapture(e.pointerId); } catch (_) {}
      document.body.setAttribute('data-sheet-dragging', 'true');
    });
    elSheetHandle.addEventListener('pointermove', function (e) {
      if (!s.dragging || e.pointerId !== s.pointerId) return;
      var dy = e.clientY - s.startY;
      if (Math.abs(dy) > DRAG_THRESHOLD) s.moved = true;
      var origin = s.mode === 'full' ? 0 : (s.sheetH - s.peekH);
      var clamped = Math.max(0, Math.min(s.sheetH - s.peekH, origin + dy));
      elSheet.style.transform = 'translateY(' + clamped + 'px)';
      var now = performance.now(), dt = Math.max(1, now - s.lastT);
      s.velocity = (e.clientY - s.lastY) / dt; s.lastY = e.clientY; s.lastT = now;
    });
    function endDrag(e) {
      if (!s.dragging) return;
      if (e && e.pointerId !== s.pointerId) return;
      s.dragging = false;
      document.body.removeAttribute('data-sheet-dragging');
      try { elSheetHandle.releasePointerCapture(s.pointerId); } catch (_) {}
      if (!s.moved) { setMode(s.mode === 'full' ? 'peek' : 'full'); return; }
      if (Math.abs(s.velocity) > FLICK_VELOCITY) { setMode(s.velocity < 0 ? 'full' : 'peek'); return; }
      var m = elSheet.style.transform.match(/translateY\((-?[\d.]+)px\)/);
      var ty = m ? parseFloat(m[1]) : 0;
      setMode(ty < (s.sheetH - s.peekH) / 2 ? 'full' : 'peek');
    }
    elSheetHandle.addEventListener('pointerup', endDrag);
    elSheetHandle.addEventListener('pointercancel', endDrag);
    elSheetHandle.addEventListener('keydown', function (e) {
      if (!isMobile()) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setMode(s.mode === 'full' ? 'peek' : 'full'); }
      if (e.key === 'Escape' && s.mode === 'full') { e.preventDefault(); setMode('peek'); }
    });
    setBodyState();
  })();

  /* ---------- Init ---------- */
  applyQueryPresets();
  elSizeUnitBtns.forEach(function (b) {
    b.setAttribute('aria-pressed', b.dataset.sizeUnit === state.sizeUnit ? 'true' : 'false');
  });
  renderSizeList();
  renderColours();
  renderStripePicker();
  if (elStripeWrap) elStripeWrap.hidden = !usesPatternColour();
  if (elStripeCustom) {
    elStripeCustom.addEventListener('input', function () { setStripeColour(elStripeCustom.value); });
  }
  // Personalisation init.
  if (persAvailable() && elPersWrap) {
    elPersWrap.hidden = false;
    renderPersFonts();
    updateLogoFields();
    loadPersFonts();
  }
  selectVariant(state.variant);

  // One-shot handoff from the finish gallery (/pages/picture-mounts): a photo the
  // visitor uploaded there, stashed in sessionStorage (the objectURL can't cross
  // the navigation). Pre-load it into the cropper so they land ready to position.
  (function () {
    var data;
    try { data = sessionStorage.getItem('pfc-mount-handoff'); } catch (_) { return; }
    if (!data) return;
    try { sessionStorage.removeItem('pfc-mount-handoff'); } catch (_) {}
    function openIt() {
      state.originalUrl = data;
      state.cropData = null;
      openCropperWithUrl(data);
    }
    if (typeof Cropper !== 'undefined') openIt();
    else window.addEventListener('load', openIt, { once: true });
  })();
})();

